var items = {
  "block.minecraft.acacia_button": "Akasya Düğme",
  "block.minecraft.acacia_door": "Akasya Kapı",
  "block.minecraft.acacia_fence": "Akasya Çit",
  "block.minecraft.acacia_fence_gate": "Akasya Çit Kapısı",
  "block.minecraft.acacia_hanging_sign": "Asılı Akasya Tabela",
  "block.minecraft.acacia_leaves": "Akasya Yaprakları",
  "block.minecraft.acacia_log": "Akasya Kütüğü",
  "block.minecraft.acacia_planks": "Akasya Tahtası",
  "block.minecraft.acacia_pressure_plate": "Akasya Basınç Plakası",
  "block.minecraft.acacia_sapling": "Akasya Fidanı",
  "block.minecraft.acacia_shelf": "Akasya Raf",
  "block.minecraft.acacia_sign": "Akasya Tabela",
  "block.minecraft.acacia_slab": "Akasya Basamak",
  "block.minecraft.acacia_stairs": "Akasya Merdiven",
  "block.minecraft.acacia_trapdoor": "Akasya Tuzak Kapısı",
  "block.minecraft.acacia_wall_hanging_sign": "Asılı Akasya Duvar Tabelası",
  "block.minecraft.acacia_wall_sign": "Akasya Duvar Tabelası",
  "block.minecraft.acacia_wood": "Akasya Odunu",
  "block.minecraft.activator_rail": "Etkinleştirici Ray",
  "block.minecraft.air": "Hava",
  "block.minecraft.allium": "Alyum",
  "block.minecraft.amethyst_block": "Ametist Bloğu",
  "block.minecraft.amethyst_cluster": "Ametist Demeti",
  "block.minecraft.ancient_debris": "Antik Kalıntı",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezit Basamak",
  "block.minecraft.andesite_stairs": "Andezit Merdiven",
  "block.minecraft.andesite_wall": "Andezit Duvar",
  "block.minecraft.anvil": "Örs",
  "block.minecraft.attached_melon_stem": "Bağlı Karpuz Sapı",
  "block.minecraft.attached_pumpkin_stem": "Bağlı Bal Kabağı Sapı",
  "block.minecraft.azalea": "Açelya",
  "block.minecraft.azalea_leaves": "Açelya Yaprakları",
  "block.minecraft.azure_bluet": "Beyaz Peygamber Çiçeği",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Bambu Bloğu",
  "block.minecraft.bamboo_button": "Bambu Düğme",
  "block.minecraft.bamboo_door": "Bambu Kapı",
  "block.minecraft.bamboo_fence": "Bambu Çit",
  "block.minecraft.bamboo_fence_gate": "Bambu Çit Kapısı",
  "block.minecraft.bamboo_hanging_sign": "Asılı Bambu Tabela",
  "block.minecraft.bamboo_mosaic": "Bambu Mozaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambu Mozaik Basamak",
  "block.minecraft.bamboo_mosaic_stairs": "Bambu Mozaik Merdiven",
  "block.minecraft.bamboo_planks": "Bambu Tahtası",
  "block.minecraft.bamboo_pressure_plate": "Bambu Basınç Plakası",
  "block.minecraft.bamboo_sapling": "Bambu Filizi",
  "block.minecraft.bamboo_shelf": "Bambu Raf",
  "block.minecraft.bamboo_sign": "Bambu Tabela",
  "block.minecraft.bamboo_slab": "Bambu Basamak",
  "block.minecraft.bamboo_stairs": "Bambu Merdiven",
  "block.minecraft.bamboo_trapdoor": "Bambu Tuzak Kapısı",
  "block.minecraft.bamboo_wall_hanging_sign": "Asılı Bambu Duvar Tabelası",
  "block.minecraft.bamboo_wall_sign": "Bambu Duvar Tabelası",
  "block.minecraft.banner.base.black": "Tamamen Siyah Arka Plan",
  "block.minecraft.banner.base.blue": "Tamamen Mavi Arka Plan",
  "block.minecraft.banner.base.brown": "Tamamen Kahverengi Arka Plan",
  "block.minecraft.banner.base.cyan": "Tamamen Camgöbeği Arka Plan",
  "block.minecraft.banner.base.gray": "Tamamen Gri Arka Plan",
  "block.minecraft.banner.base.green": "Tamamen Yeşil Arka Plan",
  "block.minecraft.banner.base.light_blue": "Tamamen Açık Mavi Arka Plan",
  "block.minecraft.banner.base.light_gray": "Tamamen Açık Gri Arka Plan",
  "block.minecraft.banner.base.lime": "Tamamen Açık Yeşil Arka Plan",
  "block.minecraft.banner.base.magenta": "Tamamen Eflatun Arka Plan",
  "block.minecraft.banner.base.orange": "Tamamen Turuncu Arka Plan",
  "block.minecraft.banner.base.pink": "Tamamen Pembe Arka Plan",
  "block.minecraft.banner.base.purple": "Tamamen Mor Arka Plan",
  "block.minecraft.banner.base.red": "Tamamen Kırmızı Arka Plan",
  "block.minecraft.banner.base.white": "Tamamen Beyaz Arka Plan",
  "block.minecraft.banner.base.yellow": "Tamamen Sarı Arka Plan",
  "block.minecraft.banner.border.black": "Siyah Çerçeve",
  "block.minecraft.banner.border.blue": "Mavi Çerçeve",
  "block.minecraft.banner.border.brown": "Kahverengi Çerçeve",
  "block.minecraft.banner.border.cyan": "Camgöbeği Çerçeve",
  "block.minecraft.banner.border.gray": "Gri Çerçeve",
  "block.minecraft.banner.border.green": "Yeşil Çerçeve",
  "block.minecraft.banner.border.light_blue": "Açık Mavi Çerçeve",
  "block.minecraft.banner.border.light_gray": "Açık Gri Çerçeve",
  "block.minecraft.banner.border.lime": "Açık Yeşil Çerçeve",
  "block.minecraft.banner.border.magenta": "Eflatun Çerçeve",
  "block.minecraft.banner.border.orange": "Turuncu Çerçeve",
  "block.minecraft.banner.border.pink": "Pembe Çerçeve",
  "block.minecraft.banner.border.purple": "Mor Çerçeve",
  "block.minecraft.banner.border.red": "Kırmızı Çerçeve",
  "block.minecraft.banner.border.white": "Beyaz Çerçeve",
  "block.minecraft.banner.border.yellow": "Sarı Çerçeve",
  "block.minecraft.banner.bricks.black": "Siyah Tuğla Deseni",
  "block.minecraft.banner.bricks.blue": "Mavi Tuğla Deseni",
  "block.minecraft.banner.bricks.brown": "Kahverengi Tuğla Deseni",
  "block.minecraft.banner.bricks.cyan": "Camgöbeği Tuğla Deseni",
  "block.minecraft.banner.bricks.gray": "Gri Tuğla Deseni",
  "block.minecraft.banner.bricks.green": "Yeşil Tuğla Deseni",
  "block.minecraft.banner.bricks.light_blue": "Açık Mavi Tuğla Deseni",
  "block.minecraft.banner.bricks.light_gray": "Açık Gri Tuğla Deseni",
  "block.minecraft.banner.bricks.lime": "Açık Yeşil Tuğla Deseni",
  "block.minecraft.banner.bricks.magenta": "Eflatun Tuğla Deseni",
  "block.minecraft.banner.bricks.orange": "Turuncu Tuğla Deseni",
  "block.minecraft.banner.bricks.pink": "Pembe Tuğla Deseni",
  "block.minecraft.banner.bricks.purple": "Mor Tuğla Deseni",
  "block.minecraft.banner.bricks.red": "Kırmızı Tuğla Deseni",
  "block.minecraft.banner.bricks.white": "Beyaz Tuğla Deseni",
  "block.minecraft.banner.bricks.yellow": "Sarı Tuğla Deseni",
  "block.minecraft.banner.circle.black": "Siyah Daire",
  "block.minecraft.banner.circle.blue": "Mavi Daire",
  "block.minecraft.banner.circle.brown": "Kahverengi Daire",
  "block.minecraft.banner.circle.cyan": "Camgöbeği Daire",
  "block.minecraft.banner.circle.gray": "Gri Daire",
  "block.minecraft.banner.circle.green": "Yeşil Daire",
  "block.minecraft.banner.circle.light_blue": "Açık Mavi Daire",
  "block.minecraft.banner.circle.light_gray": "Açık Gri Daire",
  "block.minecraft.banner.circle.lime": "Açık Yeşil Daire",
  "block.minecraft.banner.circle.magenta": "Eflatun Daire",
  "block.minecraft.banner.circle.orange": "Turuncu Daire",
  "block.minecraft.banner.circle.pink": "Pembe Daire",
  "block.minecraft.banner.circle.purple": "Mor Daire",
  "block.minecraft.banner.circle.red": "Kırmızı Daire",
  "block.minecraft.banner.circle.white": "Beyaz Daire",
  "block.minecraft.banner.circle.yellow": "Sarı Daire",
  "block.minecraft.banner.creeper.black": "Siyah Creeper Şekli",
  "block.minecraft.banner.creeper.blue": "Mavi Creeper Şekli",
  "block.minecraft.banner.creeper.brown": "Kahverengi Creeper Şekli",
  "block.minecraft.banner.creeper.cyan": "Camgöbeği Creeper Şekli",
  "block.minecraft.banner.creeper.gray": "Gri Creeper Şekli",
  "block.minecraft.banner.creeper.green": "Yeşil Creeper Şekli",
  "block.minecraft.banner.creeper.light_blue": "Açık Mavi Creeper Şekli",
  "block.minecraft.banner.creeper.light_gray": "Açık Gri Creeper Şekli",
  "block.minecraft.banner.creeper.lime": "Açık Yeşil Creeper Şekli",
  "block.minecraft.banner.creeper.magenta": "Eflatun Creeper Şekli",
  "block.minecraft.banner.creeper.orange": "Turuncu Creeper Şekli",
  "block.minecraft.banner.creeper.pink": "Pembe Creeper Şekli",
  "block.minecraft.banner.creeper.purple": "Mor Creeper Şekli",
  "block.minecraft.banner.creeper.red": "Kırmızı Creeper Şekli",
  "block.minecraft.banner.creeper.white": "Beyaz Ürperten Şekli",
  "block.minecraft.banner.creeper.yellow": "Sarı Creeper Şekli",
  "block.minecraft.banner.cross.black": "Siyah Çarpı",
  "block.minecraft.banner.cross.blue": "Mavi Çarpı",
  "block.minecraft.banner.cross.brown": "Kahverengi Çarpı",
  "block.minecraft.banner.cross.cyan": "Camgöbeği Çarpı",
  "block.minecraft.banner.cross.gray": "Gri Çarpı",
  "block.minecraft.banner.cross.green": "Yeşil Çarpı",
  "block.minecraft.banner.cross.light_blue": "Açık Mavi Çarpı",
  "block.minecraft.banner.cross.light_gray": "Açık Gri Çarpı",
  "block.minecraft.banner.cross.lime": "Açık Yeşil Çarpı",
  "block.minecraft.banner.cross.magenta": "Eflatun Çarpı",
  "block.minecraft.banner.cross.orange": "Turuncu Çarpı",
  "block.minecraft.banner.cross.pink": "Pembe Çarpı",
  "block.minecraft.banner.cross.purple": "Mor Çarpı",
  "block.minecraft.banner.cross.red": "Kırmızı Çarpı",
  "block.minecraft.banner.cross.white": "Beyaz Çarpı",
  "block.minecraft.banner.cross.yellow": "Sarı Çarpı",
  "block.minecraft.banner.curly_border.black": "Siyah Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.blue": "Mavi Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.brown": "Kahverengi Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.cyan": "Camgöbeği Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.gray": "Gri Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.green": "Yeşil Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.light_blue": "Açık Mavi Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.light_gray": "Açık Gri Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.lime": "Açık Yeşil Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.magenta": "Eflatun Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.orange": "Turuncu Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.pink": "Pembe Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.purple": "Mor Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.red": "Kırmızı Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.white": "Beyaz Testere Dişi Çerçeve",
  "block.minecraft.banner.curly_border.yellow": "Sarı Testere Dişi Çerçeve",
  "block.minecraft.banner.diagonal_left.black": "Siyah Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.blue": "Mavi Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.brown": "Kahverengi Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.cyan": "Camgöbeği Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.gray": "Gri Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.green": "Yeşil Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.light_blue": "Açık Mavi Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.light_gray": "Açık Gri Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.lime": "Açık Yeşil Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.magenta": "Eflatun Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.orange": "Turuncu Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.pink": "Pembe Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.purple": "Mor Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.red": "Kırmızı Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.white": "Beyaz Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_left.yellow": "Sarı Sol Üst Üçgen",
  "block.minecraft.banner.diagonal_right.black": "Siyah Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.blue": "Mavi Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.brown": "Kahverengi Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.cyan": "Camgöbeği Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.gray": "Gri Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.green": "Yeşil Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.light_blue": "Açık Mavi Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.light_gray": "Açık Gri Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.lime": "Açık Yeşil Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.magenta": "Eflatun Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.orange": "Turuncu Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.pink": "Pembe Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.purple": "Mor Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.red": "Kırmızı Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.white": "Beyaz Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_right.yellow": "Sarı Sağ Üst Üçgen",
  "block.minecraft.banner.diagonal_up_left.black": "Siyah Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.blue": "Mavi Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.brown": "Kahverengi Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.cyan": "Camgöbeği Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.gray": "Gri Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.green": "Yeşil Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Açık Mavi Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Açık Gri Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.lime": "Açık Yeşil Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.magenta": "Eflatun Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.orange": "Turuncu Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.pink": "Pembe Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.purple": "Mor Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.red": "Kırmızı Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.white": "Beyaz Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_left.yellow": "Sarı Sol Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.black": "Siyah Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.blue": "Mavi Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.brown": "Kahverengi Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.cyan": "Camgöbeği Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.gray": "Gri Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.green": "Yeşil Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Açık Mavi Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Açık Gri Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.lime": "Açık Yeşil Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.magenta": "Eflatun Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.orange": "Turuncu Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.pink": "Pembe Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.purple": "Mor Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.red": "Kırmızı Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.white": "Beyaz Sağ Alt Üçgen",
  "block.minecraft.banner.diagonal_up_right.yellow": "Sarı Sağ Alt Üçgen",
  "block.minecraft.banner.flow.black": "Siyah Akış",
  "block.minecraft.banner.flow.blue": "Mavi Akış",
  "block.minecraft.banner.flow.brown": "Kahverengi Akış",
  "block.minecraft.banner.flow.cyan": "Camgöbeği Akış",
  "block.minecraft.banner.flow.gray": "Gri Akış",
  "block.minecraft.banner.flow.green": "Yeşil Akış",
  "block.minecraft.banner.flow.light_blue": "Açık Mavi Akış",
  "block.minecraft.banner.flow.light_gray": "Açık Gri Akış",
  "block.minecraft.banner.flow.lime": "Açık Yeşil Akış",
  "block.minecraft.banner.flow.magenta": "Eflatun Akış",
  "block.minecraft.banner.flow.orange": "Turuncu Akış",
  "block.minecraft.banner.flow.pink": "Pembe Akış",
  "block.minecraft.banner.flow.purple": "Mor Akış",
  "block.minecraft.banner.flow.red": "Kırmızı Akış",
  "block.minecraft.banner.flow.white": "Beyaz Akış",
  "block.minecraft.banner.flow.yellow": "Sarı Akış",
  "block.minecraft.banner.flower.black": "Siyah Çiçek Şekli",
  "block.minecraft.banner.flower.blue": "Mavi Çiçek Şekli",
  "block.minecraft.banner.flower.brown": "Kahverengi Çiçek Şekli",
  "block.minecraft.banner.flower.cyan": "Camgöbeği Çiçek Şekli",
  "block.minecraft.banner.flower.gray": "Gri Çiçek Şekli",
  "block.minecraft.banner.flower.green": "Yeşil Çiçek Şekli",
  "block.minecraft.banner.flower.light_blue": "Açık Mavi Çiçek Şekli",
  "block.minecraft.banner.flower.light_gray": "Açık Gri Çiçek Şekli",
  "block.minecraft.banner.flower.lime": "Açık Yeşil Çiçek Şekli",
  "block.minecraft.banner.flower.magenta": "Eflatun Çiçek Şekli",
  "block.minecraft.banner.flower.orange": "Turuncu Çiçek Şekli",
  "block.minecraft.banner.flower.pink": "Pembe Çiçek Şekli",
  "block.minecraft.banner.flower.purple": "Mor Çiçek Şekli",
  "block.minecraft.banner.flower.red": "Kırmızı Çiçek Şekli",
  "block.minecraft.banner.flower.white": "Beyaz Çiçek Şekli",
  "block.minecraft.banner.flower.yellow": "Sarı Çiçek Şekli",
  "block.minecraft.banner.globe.black": "Siyah Dünya",
  "block.minecraft.banner.globe.blue": "Mavi Dünya",
  "block.minecraft.banner.globe.brown": "Kahverengi Dünya",
  "block.minecraft.banner.globe.cyan": "Camgöbeği Dünya",
  "block.minecraft.banner.globe.gray": "Gri Dünya",
  "block.minecraft.banner.globe.green": "Yeşil Dünya",
  "block.minecraft.banner.globe.light_blue": "Açık Mavi Dünya",
  "block.minecraft.banner.globe.light_gray": "Açık Gri Dünya",
  "block.minecraft.banner.globe.lime": "Açık Yeşil Dünya",
  "block.minecraft.banner.globe.magenta": "Eflatun Dünya",
  "block.minecraft.banner.globe.orange": "Turuncu Dünya",
  "block.minecraft.banner.globe.pink": "Pembe Dünya",
  "block.minecraft.banner.globe.purple": "Mor Dünya",
  "block.minecraft.banner.globe.red": "Kırmızı Dünya",
  "block.minecraft.banner.globe.white": "Beyaz Dünya",
  "block.minecraft.banner.globe.yellow": "Sarı Dünya",
  "block.minecraft.banner.gradient.black": "Yukarıdan Aşağı Siyah Geçiş",
  "block.minecraft.banner.gradient.blue": "Yukarıdan Aşağı Mavi Geçiş",
  "block.minecraft.banner.gradient.brown": "Yukarıdan Aşağı Kahverengi Geçiş",
  "block.minecraft.banner.gradient.cyan": "Yukarıdan Aşağı Camgöbeği Geçiş",
  "block.minecraft.banner.gradient.gray": "Yukarıdan Aşağı Gri Geçiş",
  "block.minecraft.banner.gradient.green": "Yukarıdan Aşağı Yeşil Geçiş",
  "block.minecraft.banner.gradient.light_blue": "Yukarıdan Aşağı Açık Mavi Geçiş",
  "block.minecraft.banner.gradient.light_gray": "Yukarıdan Aşağı Açık Gri Geçiş",
  "block.minecraft.banner.gradient.lime": "Yukarıdan Aşağı Açık Yeşil Geçiş",
  "block.minecraft.banner.gradient.magenta": "Yukarıdan Aşağı Eflatun Geçiş",
  "block.minecraft.banner.gradient.orange": "Yukarıdan Aşağı Turuncu Geçiş",
  "block.minecraft.banner.gradient.pink": "Yukarıdan Aşağı Pembe Geçiş",
  "block.minecraft.banner.gradient.purple": "Yukarıdan Aşağı Mor Geçiş",
  "block.minecraft.banner.gradient.red": "Yukarıdan Aşağı Kırmızı Geçiş",
  "block.minecraft.banner.gradient.white": "Yukarıdan Aşağı Beyaz Geçiş",
  "block.minecraft.banner.gradient.yellow": "Yukarıdan Aşağı Sarı Geçiş",
  "block.minecraft.banner.gradient_up.black": "Aşağıdan Yukarı Siyah Geçiş",
  "block.minecraft.banner.gradient_up.blue": "Aşağıdan Yukarı Mavi Geçiş",
  "block.minecraft.banner.gradient_up.brown": "Aşağıdan Yukarı Kahverengi Geçiş",
  "block.minecraft.banner.gradient_up.cyan": "Aşağıdan Yukarı Camgöbeği Geçiş",
  "block.minecraft.banner.gradient_up.gray": "Aşağıdan Yukarı Gri Geçiş",
  "block.minecraft.banner.gradient_up.green": "Aşağıdan Yukarı Yeşil Geçiş",
  "block.minecraft.banner.gradient_up.light_blue": "Aşağıdan Yukarı Sarı Geçiş",
  "block.minecraft.banner.gradient_up.light_gray": "Aşağıdan Yukarı Açık Gri Geçiş",
  "block.minecraft.banner.gradient_up.lime": "Aşağıdan Yukarı Açık Yeşil Geçiş",
  "block.minecraft.banner.gradient_up.magenta": "Aşağıdan Yukarı Eflatun Geçiş",
  "block.minecraft.banner.gradient_up.orange": "Aşağıdan Yukarı Turuncu Geçiş",
  "block.minecraft.banner.gradient_up.pink": "Aşağıdan Yukarı Pembe Geçiş",
  "block.minecraft.banner.gradient_up.purple": "Aşağıdan Yukarı Mor Geçiş",
  "block.minecraft.banner.gradient_up.red": "Aşağıdan Yukarı Kırmızı Geçiş",
  "block.minecraft.banner.gradient_up.white": "Aşağıdan Yukarı Beyaz Geçiş",
  "block.minecraft.banner.gradient_up.yellow": "Aşağıdan Yukarı Sarı Geçiş",
  "block.minecraft.banner.guster.black": "Siyah Fırtına",
  "block.minecraft.banner.guster.blue": "Mavi Fırtına",
  "block.minecraft.banner.guster.brown": "Kahverengi Fırtına",
  "block.minecraft.banner.guster.cyan": "Camgöbeği Fırtına",
  "block.minecraft.banner.guster.gray": "Gri Fırtına",
  "block.minecraft.banner.guster.green": "Yeşil Fırtına",
  "block.minecraft.banner.guster.light_blue": "Açık Mavi Fırtına",
  "block.minecraft.banner.guster.light_gray": "Açık Gri Fırtına",
  "block.minecraft.banner.guster.lime": "Açık Yeşil Fırtına",
  "block.minecraft.banner.guster.magenta": "Eflatun Fırtına",
  "block.minecraft.banner.guster.orange": "Turuncu Fırtına",
  "block.minecraft.banner.guster.pink": "Pembe Fırtına",
  "block.minecraft.banner.guster.purple": "Mor Fırtına",
  "block.minecraft.banner.guster.red": "Kırmızı Fırtına",
  "block.minecraft.banner.guster.white": "Beyaz Fırtına",
  "block.minecraft.banner.guster.yellow": "Sarı Fırtına",
  "block.minecraft.banner.half_horizontal.black": "Siyah Üst Yarı",
  "block.minecraft.banner.half_horizontal.blue": "Mavi Üst Yarı",
  "block.minecraft.banner.half_horizontal.brown": "Kahverengi Üst Yarı",
  "block.minecraft.banner.half_horizontal.cyan": "Camgöbeği Üst Yarı",
  "block.minecraft.banner.half_horizontal.gray": "Gri Üst Yarı",
  "block.minecraft.banner.half_horizontal.green": "Yeşil Üst Yarı",
  "block.minecraft.banner.half_horizontal.light_blue": "Açık Mavi Üst Yarı",
  "block.minecraft.banner.half_horizontal.light_gray": "Açık Gri Üst Yarı",
  "block.minecraft.banner.half_horizontal.lime": "Açık Yeşil Üst Yarı",
  "block.minecraft.banner.half_horizontal.magenta": "Eflatun Üst Yarı",
  "block.minecraft.banner.half_horizontal.orange": "Turuncu Üst Yarı",
  "block.minecraft.banner.half_horizontal.pink": "Pembe Üst Yarı",
  "block.minecraft.banner.half_horizontal.purple": "Mor Üst Yarı",
  "block.minecraft.banner.half_horizontal.red": "Kırmızı Üst Yarı",
  "block.minecraft.banner.half_horizontal.white": "Beyaz Üst Yarı",
  "block.minecraft.banner.half_horizontal.yellow": "Sarı Üst Yarı",
  "block.minecraft.banner.half_horizontal_bottom.black": "Siyah Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Mavi Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Kahverengi Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Camgöbeği Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gri Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.green": "Yeşil Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Açık Mavi Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Açık Gri Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Açık Yeşil Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Eflatun Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Turuncu Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Pembe Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Mor Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.red": "Kırmızı Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.white": "Beyaz Alt Yarı",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Sarı Alt Yarı",
  "block.minecraft.banner.half_vertical.black": "Siyah Sol Yarı",
  "block.minecraft.banner.half_vertical.blue": "Mavi Sol Yarı",
  "block.minecraft.banner.half_vertical.brown": "Kahverengi Sol Yarı",
  "block.minecraft.banner.half_vertical.cyan": "Camgöbeği Sol Yarı",
  "block.minecraft.banner.half_vertical.gray": "Gri Sol Yarı",
  "block.minecraft.banner.half_vertical.green": "Yeşil Sol Yarı",
  "block.minecraft.banner.half_vertical.light_blue": "Açık Mavi Sol Yarı",
  "block.minecraft.banner.half_vertical.light_gray": "Açık Gri Sol Yarı",
  "block.minecraft.banner.half_vertical.lime": "Açık Yeşil Sol Yarı",
  "block.minecraft.banner.half_vertical.magenta": "Eflatun Sol Yarı",
  "block.minecraft.banner.half_vertical.orange": "Turuncu Sol Yarı",
  "block.minecraft.banner.half_vertical.pink": "Pembe Sol Yarı",
  "block.minecraft.banner.half_vertical.purple": "Mor Sol Yarı",
  "block.minecraft.banner.half_vertical.red": "Kırmızı Sol Yarı",
  "block.minecraft.banner.half_vertical.white": "Beyaz Sol Yarı",
  "block.minecraft.banner.half_vertical.yellow": "Sarı Sol Yarı",
  "block.minecraft.banner.half_vertical_right.black": "Siyah Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.blue": "Mavi Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.brown": "Kahverengi Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.cyan": "Camgöbeği Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.gray": "Gri Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.green": "Yeşil Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.light_blue": "Açık Mavi Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.light_gray": "Açık Gri Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.lime": "Açık Yeşil Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.magenta": "Eflatun Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.orange": "Turuncu Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.pink": "Pembe Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.purple": "Mor Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.red": "Kırmızı Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.white": "Beyaz Sağ Yarı",
  "block.minecraft.banner.half_vertical_right.yellow": "Sarı Sağ Yarı",
  "block.minecraft.banner.mojang.black": "Siyah Şey",
  "block.minecraft.banner.mojang.blue": "Mavi Şey",
  "block.minecraft.banner.mojang.brown": "Kahverengi Şey",
  "block.minecraft.banner.mojang.cyan": "Camgöbeği Şey",
  "block.minecraft.banner.mojang.gray": "Gri Şey",
  "block.minecraft.banner.mojang.green": "Yeşil Şey",
  "block.minecraft.banner.mojang.light_blue": "Açık Mavi Şey",
  "block.minecraft.banner.mojang.light_gray": "Açık Gri Şey",
  "block.minecraft.banner.mojang.lime": "Açık Yeşil Şey",
  "block.minecraft.banner.mojang.magenta": "Eflatun Şey",
  "block.minecraft.banner.mojang.orange": "Turuncu Şey",
  "block.minecraft.banner.mojang.pink": "Pembe Şey",
  "block.minecraft.banner.mojang.purple": "Mor Şey",
  "block.minecraft.banner.mojang.red": "Kırmızı Şey",
  "block.minecraft.banner.mojang.white": "Beyaz Şey",
  "block.minecraft.banner.mojang.yellow": "Sarı Şey",
  "block.minecraft.banner.piglin.black": "Siyah Domuz Burnu",
  "block.minecraft.banner.piglin.blue": "Mavi Domuz Burnu",
  "block.minecraft.banner.piglin.brown": "Kahverengi Domuz Burnu",
  "block.minecraft.banner.piglin.cyan": "Camgöbeği Domuz Burnu",
  "block.minecraft.banner.piglin.gray": "Gri Domuz Burnu",
  "block.minecraft.banner.piglin.green": "Yeşil Domuz Burnu",
  "block.minecraft.banner.piglin.light_blue": "Açık Mavi Domuz Burnu",
  "block.minecraft.banner.piglin.light_gray": "Açık Gri Domuz Burnu",
  "block.minecraft.banner.piglin.lime": "Açık Yeşil Domuz Burnu",
  "block.minecraft.banner.piglin.magenta": "Eflatun Domuz Burnu",
  "block.minecraft.banner.piglin.orange": "Turuncu Domuz Burnu",
  "block.minecraft.banner.piglin.pink": "Pembe Domuz Burnu",
  "block.minecraft.banner.piglin.purple": "Mor Domuz Burnu",
  "block.minecraft.banner.piglin.red": "Kırmızı Domuz Burnu",
  "block.minecraft.banner.piglin.white": "Beyaz Domuz Burnu",
  "block.minecraft.banner.piglin.yellow": "Sarı Domuz Burnu",
  "block.minecraft.banner.rhombus.black": "Siyah Karo",
  "block.minecraft.banner.rhombus.blue": "Mavi Karo",
  "block.minecraft.banner.rhombus.brown": "Kahverengi Karo",
  "block.minecraft.banner.rhombus.cyan": "Camgöbeği Karo",
  "block.minecraft.banner.rhombus.gray": "Gri Karo",
  "block.minecraft.banner.rhombus.green": "Yeşil Karo",
  "block.minecraft.banner.rhombus.light_blue": "Açık Mavi Karo",
  "block.minecraft.banner.rhombus.light_gray": "Açık Gri Karo",
  "block.minecraft.banner.rhombus.lime": "Açık Yeşil Karo",
  "block.minecraft.banner.rhombus.magenta": "Eflatun Karo",
  "block.minecraft.banner.rhombus.orange": "Turuncu Karo",
  "block.minecraft.banner.rhombus.pink": "Pembe Karo",
  "block.minecraft.banner.rhombus.purple": "Mor Karo",
  "block.minecraft.banner.rhombus.red": "Kırmızı Karo",
  "block.minecraft.banner.rhombus.white": "Beyaz Karo",
  "block.minecraft.banner.rhombus.yellow": "Sarı Karo",
  "block.minecraft.banner.skull.black": "Siyah Kuru Kafa Şekli",
  "block.minecraft.banner.skull.blue": "Mavi Kuru Kafa Şekli",
  "block.minecraft.banner.skull.brown": "Kahverengi Kuru Kafa Şekli",
  "block.minecraft.banner.skull.cyan": "Camgöbeği Kuru Kafa Şekli",
  "block.minecraft.banner.skull.gray": "Gri Kuru Kafa Şekli",
  "block.minecraft.banner.skull.green": "Yeşil Kuru Kafa Şekli",
  "block.minecraft.banner.skull.light_blue": "Açık Mavi Kuru Kafa Şekli",
  "block.minecraft.banner.skull.light_gray": "Açık Gri Kuru Kafa Şekli",
  "block.minecraft.banner.skull.lime": "Açık Yeşil Kuru Kafa Şekli",
  "block.minecraft.banner.skull.magenta": "Eflatun Kuru Kafa Şekli",
  "block.minecraft.banner.skull.orange": "Turuncu Kuru Kafa Şekli",
  "block.minecraft.banner.skull.pink": "Pembe Kuru Kafa Şekli",
  "block.minecraft.banner.skull.purple": "Mor Kuru Kafa Şekli",
  "block.minecraft.banner.skull.red": "Kırmızı Kuru Kafa Şekli",
  "block.minecraft.banner.skull.white": "Beyaz Kuru Kafa Şekli",
  "block.minecraft.banner.skull.yellow": "Sarı Kuru Kafa Şekli",
  "block.minecraft.banner.small_stripes.black": "Siyah İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.blue": "Mavi İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.brown": "Kahverengi İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.cyan": "Camgöbeği İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.gray": "Gri İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.green": "Yeşil İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.light_blue": "Açık Mavi İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.light_gray": "Açık Gri İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.lime": "Açık Yeşil İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.magenta": "Eflatun İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.orange": "Turuncu İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.pink": "Pembe İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.purple": "Mor İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.red": "Kırmızı İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.white": "Beyaz İnce Dikey Şeritler",
  "block.minecraft.banner.small_stripes.yellow": "Sarı İnce Dikey Şeritler",
  "block.minecraft.banner.square_bottom_left.black": "Siyah Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.blue": "Mavi Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.brown": "Kahverengi Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.cyan": "Camgöbeği Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.gray": "Gri Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.green": "Yeşil Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.light_blue": "Açık Mavi Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.light_gray": "Açık Gri Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.lime": "Açık Yeşil Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.magenta": "Eflatun Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.orange": "Turuncu Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.pink": "Pembe Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.purple": "Mor Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.red": "Kırmızı Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.white": "Beyaz Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_left.yellow": "Sarı Sol Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.black": "Siyah Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.blue": "Mavi Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.brown": "Kahverengi Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.cyan": "Camgöbeği Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.gray": "Gri Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.green": "Yeşil Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.light_blue": "Açık Mavi Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.light_gray": "Açık Gri Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.lime": "Açık Yeşil Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.magenta": "Eflatun Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.orange": "Turuncu Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.pink": "Pembe Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.purple": "Mor Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.red": "Kırmızı Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.white": "Beyaz Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_bottom_right.yellow": "Sarı Sağ Alt Dikdörtgen",
  "block.minecraft.banner.square_top_left.black": "Siyah Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.blue": "Mavi Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.brown": "Kahverengi Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.cyan": "Camgöbeği Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.gray": "Gri Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.green": "Yeşil Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.light_blue": "Açık Mavi Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.light_gray": "Açık Gri Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.lime": "Açık Yeşil Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.magenta": "Eflatun Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.orange": "Turuncu Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.pink": "Pembe Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.purple": "Mor Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.red": "Kırmızı Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.white": "Beyaz Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_left.yellow": "Sarı Sol Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.black": "Siyah Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.blue": "Mavi Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.brown": "Kahverengi Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.cyan": "Camgöbeği Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.gray": "Gri Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.green": "Yeşil Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.light_blue": "Açık Mavi Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.light_gray": "Açık Gri Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.lime": "Açık Yeşil Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.magenta": "Eflatun Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.orange": "Turuncu Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.pink": "Pembe Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.purple": "Mor Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.red": "Kırmızı Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.white": "Beyaz Sağ Üst Dikdörtgen",
  "block.minecraft.banner.square_top_right.yellow": "Sarı Sağ Üst Dikdörtgen",
  "block.minecraft.banner.straight_cross.black": "Siyah Haç",
  "block.minecraft.banner.straight_cross.blue": "Mavi Haç",
  "block.minecraft.banner.straight_cross.brown": "Kahverengi Haç",
  "block.minecraft.banner.straight_cross.cyan": "Camgöbeği Haç",
  "block.minecraft.banner.straight_cross.gray": "Gri Haç",
  "block.minecraft.banner.straight_cross.green": "Yeşil Haç",
  "block.minecraft.banner.straight_cross.light_blue": "Açık Mavi Haç",
  "block.minecraft.banner.straight_cross.light_gray": "Açık Gri Haç",
  "block.minecraft.banner.straight_cross.lime": "Açık Yeşil Haç",
  "block.minecraft.banner.straight_cross.magenta": "Eflatun Haç",
  "block.minecraft.banner.straight_cross.orange": "Turuncu Haç",
  "block.minecraft.banner.straight_cross.pink": "Pembe Haç",
  "block.minecraft.banner.straight_cross.purple": "Mor Haç",
  "block.minecraft.banner.straight_cross.red": "Kırmızı Haç",
  "block.minecraft.banner.straight_cross.white": "Beyaz Haç",
  "block.minecraft.banner.straight_cross.yellow": "Sarı Haç",
  "block.minecraft.banner.stripe_bottom.black": "Altta Siyah Şerit",
  "block.minecraft.banner.stripe_bottom.blue": "Altta Mavi Şerit",
  "block.minecraft.banner.stripe_bottom.brown": "Altta Kahverengi Şerit",
  "block.minecraft.banner.stripe_bottom.cyan": "Altta Camgöbeği Şerit",
  "block.minecraft.banner.stripe_bottom.gray": "Altta Gri Şerit",
  "block.minecraft.banner.stripe_bottom.green": "Altta Yeşil Şerit",
  "block.minecraft.banner.stripe_bottom.light_blue": "Altta Açık Mavi Şerit",
  "block.minecraft.banner.stripe_bottom.light_gray": "Altta Açık Gri Şerit",
  "block.minecraft.banner.stripe_bottom.lime": "Altta Açık Yeşil Şerit",
  "block.minecraft.banner.stripe_bottom.magenta": "Altta Eflatun Şerit",
  "block.minecraft.banner.stripe_bottom.orange": "Altta Turuncu Şerit",
  "block.minecraft.banner.stripe_bottom.pink": "Altta Pembe Şerit",
  "block.minecraft.banner.stripe_bottom.purple": "Altta Mor Şerit",
  "block.minecraft.banner.stripe_bottom.red": "Altta Kırmızı Şerit",
  "block.minecraft.banner.stripe_bottom.white": "Altta Beyaz Şerit",
  "block.minecraft.banner.stripe_bottom.yellow": "Altta Sarı Şerit",
  "block.minecraft.banner.stripe_center.black": "Ortada Siyah Dikey Şerit",
  "block.minecraft.banner.stripe_center.blue": "Ortada Mavi Dikey Şerit",
  "block.minecraft.banner.stripe_center.brown": "Ortada Kahverengi Dikey Şerit",
  "block.minecraft.banner.stripe_center.cyan": "Ortada Camgöbeği Dikey Şerit",
  "block.minecraft.banner.stripe_center.gray": "Ortada Gri Dikey Şerit",
  "block.minecraft.banner.stripe_center.green": "Ortada Yeşil Dikey Şerit",
  "block.minecraft.banner.stripe_center.light_blue": "Ortada Açık Mavi Dikey Şerit",
  "block.minecraft.banner.stripe_center.light_gray": "Ortada Açık Gri Dikey Şerit",
  "block.minecraft.banner.stripe_center.lime": "Ortada Açık Yeşil Dikey Şerit",
  "block.minecraft.banner.stripe_center.magenta": "Ortada Eflatun Dikey Şerit",
  "block.minecraft.banner.stripe_center.orange": "Ortada Turuncu Dikey Şerit",
  "block.minecraft.banner.stripe_center.pink": "Ortada Pembe Dikey Şerit",
  "block.minecraft.banner.stripe_center.purple": "Ortada Mor Dikey Şerit",
  "block.minecraft.banner.stripe_center.red": "Ortada Kırmızı Dikey Şerit",
  "block.minecraft.banner.stripe_center.white": "Ortada Beyaz Dikey Şerit",
  "block.minecraft.banner.stripe_center.yellow": "Ortada Sarı Dikey Şerit",
  "block.minecraft.banner.stripe_downleft.black": "Siyah Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.blue": "Mavi Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.brown": "Kahverengi Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.cyan": "Camgöbeği Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.gray": "Gri Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.green": "Yeşil Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.light_blue": "Açık Mavi Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.light_gray": "Açık Gri Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.lime": "Açık Yeşil Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.magenta": "Eflatun Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.orange": "Turuncu Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.pink": "Pembe Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.purple": "Mor Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.red": "Kırmızı Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.white": "Beyaz Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downleft.yellow": "Sarı Ters Eğik Şerit",
  "block.minecraft.banner.stripe_downright.black": "Siyah Eğik Şerit",
  "block.minecraft.banner.stripe_downright.blue": "Mavi Eğik Şerit",
  "block.minecraft.banner.stripe_downright.brown": "Kahverengi Eğik Şerit",
  "block.minecraft.banner.stripe_downright.cyan": "Camgöbeği Eğik Şerit",
  "block.minecraft.banner.stripe_downright.gray": "Gri Eğik Şerit",
  "block.minecraft.banner.stripe_downright.green": "Yeşil Eğik Şerit",
  "block.minecraft.banner.stripe_downright.light_blue": "Açık Mavi Eğik Şerit",
  "block.minecraft.banner.stripe_downright.light_gray": "Açık Gri Eğik Şerit",
  "block.minecraft.banner.stripe_downright.lime": "Açık Yeşil Eğik Şerit",
  "block.minecraft.banner.stripe_downright.magenta": "Eflatun Eğik Şerit",
  "block.minecraft.banner.stripe_downright.orange": "Turuncu Eğik Şerit",
  "block.minecraft.banner.stripe_downright.pink": "Pembe Eğik Şerit",
  "block.minecraft.banner.stripe_downright.purple": "Mor Eğik Şerit",
  "block.minecraft.banner.stripe_downright.red": "Kırmızı Eğik Şerit",
  "block.minecraft.banner.stripe_downright.white": "Beyaz Eğik Şerit",
  "block.minecraft.banner.stripe_downright.yellow": "Sarı Eğik Şerit",
  "block.minecraft.banner.stripe_left.black": "Solda Siyah Şerit",
  "block.minecraft.banner.stripe_left.blue": "Solda Mavi Şerit",
  "block.minecraft.banner.stripe_left.brown": "Solda Kahverengi Şerit",
  "block.minecraft.banner.stripe_left.cyan": "Solda Camgöbeği Şerit",
  "block.minecraft.banner.stripe_left.gray": "Solda Gri Şerit",
  "block.minecraft.banner.stripe_left.green": "Solda Yeşil Şerit",
  "block.minecraft.banner.stripe_left.light_blue": "Solda Açık Mavi Şerit",
  "block.minecraft.banner.stripe_left.light_gray": "Solda Açık Gri Şerit",
  "block.minecraft.banner.stripe_left.lime": "Solda Açık Yeşil Şerit",
  "block.minecraft.banner.stripe_left.magenta": "Solda Eflatun Şerit",
  "block.minecraft.banner.stripe_left.orange": "Solda Turuncu Şerit",
  "block.minecraft.banner.stripe_left.pink": "Solda Pembe Şerit",
  "block.minecraft.banner.stripe_left.purple": "Solda Mor Şerit",
  "block.minecraft.banner.stripe_left.red": "Solda Kırmızı Şerit",
  "block.minecraft.banner.stripe_left.white": "Solda Beyaz Şerit",
  "block.minecraft.banner.stripe_left.yellow": "Solda Sarı Şerit",
  "block.minecraft.banner.stripe_middle.black": "Ortada Siyah Yatay Şerit",
  "block.minecraft.banner.stripe_middle.blue": "Ortada Mavi Yatay Şerit",
  "block.minecraft.banner.stripe_middle.brown": "Ortada Kahverengi Yatay Şerit",
  "block.minecraft.banner.stripe_middle.cyan": "Ortada Camgöbeği Yatay Şerit",
  "block.minecraft.banner.stripe_middle.gray": "Ortada Gri Yatay Şerit",
  "block.minecraft.banner.stripe_middle.green": "Ortada Yeşil Yatay Şerit",
  "block.minecraft.banner.stripe_middle.light_blue": "Ortada Açık Mavi Yatay Şerit",
  "block.minecraft.banner.stripe_middle.light_gray": "Ortada Açık Gri Yatay Şerit",
  "block.minecraft.banner.stripe_middle.lime": "Ortada Açık Yeşil Yatay Şerit",
  "block.minecraft.banner.stripe_middle.magenta": "Ortada Eflatun Yatay Şerit",
  "block.minecraft.banner.stripe_middle.orange": "Ortada Turuncu Yatay Şerit",
  "block.minecraft.banner.stripe_middle.pink": "Ortada Pembe Yatay Şerit",
  "block.minecraft.banner.stripe_middle.purple": "Ortada Mor Yatay Şerit",
  "block.minecraft.banner.stripe_middle.red": "Ortada Kırmızı Yatay Şerit",
  "block.minecraft.banner.stripe_middle.white": "Ortada Beyaz Yatay Şerit",
  "block.minecraft.banner.stripe_middle.yellow": "Ortada Sarı Yatay Şerit",
  "block.minecraft.banner.stripe_right.black": "Sağda Siyah Şerit",
  "block.minecraft.banner.stripe_right.blue": "Sağda Mavi Şerit",
  "block.minecraft.banner.stripe_right.brown": "Sağda Kahverengi Sütun",
  "block.minecraft.banner.stripe_right.cyan": "Sağda Camgöbeği Şerit",
  "block.minecraft.banner.stripe_right.gray": "Sağda Gri Şerit",
  "block.minecraft.banner.stripe_right.green": "Sağda Yeşil Şerit",
  "block.minecraft.banner.stripe_right.light_blue": "Sağda Açık Mavi Şerit",
  "block.minecraft.banner.stripe_right.light_gray": "Sağda Açık Gri Şerit",
  "block.minecraft.banner.stripe_right.lime": "Sağda Açık Yeşil Şerit",
  "block.minecraft.banner.stripe_right.magenta": "Sağda Eflatun Şerit",
  "block.minecraft.banner.stripe_right.orange": "Sağda Turuncu Şerit",
  "block.minecraft.banner.stripe_right.pink": "Sağda Pembe Şerit",
  "block.minecraft.banner.stripe_right.purple": "Sağda Mor Şerit",
  "block.minecraft.banner.stripe_right.red": "Sağda Kırmızı Şerit",
  "block.minecraft.banner.stripe_right.white": "Sağda Beyaz Şerit",
  "block.minecraft.banner.stripe_right.yellow": "Sağda Sarı Şerit",
  "block.minecraft.banner.stripe_top.black": "Üstte Siyah Şerit",
  "block.minecraft.banner.stripe_top.blue": "Üstte Mavi Şerit",
  "block.minecraft.banner.stripe_top.brown": "Üstte Kahverengi Şerit",
  "block.minecraft.banner.stripe_top.cyan": "Üstte Camgöbeği Şerit",
  "block.minecraft.banner.stripe_top.gray": "Üstte Gri Şerit",
  "block.minecraft.banner.stripe_top.green": "Üstte Yeşil Şerit",
  "block.minecraft.banner.stripe_top.light_blue": "Üstte Açık Mavi Şerit",
  "block.minecraft.banner.stripe_top.light_gray": "Üstte Açık Gri Şerit",
  "block.minecraft.banner.stripe_top.lime": "Üstte Açık Yeşil Şerit",
  "block.minecraft.banner.stripe_top.magenta": "Üstte Eflatun Şerit",
  "block.minecraft.banner.stripe_top.orange": "Üstte Turuncu Şerit",
  "block.minecraft.banner.stripe_top.pink": "Üstte Pembe Şerit",
  "block.minecraft.banner.stripe_top.purple": "Üstte Mor Şerit",
  "block.minecraft.banner.stripe_top.red": "Üstte Kırmızı Şerit",
  "block.minecraft.banner.stripe_top.white": "Üstte Beyaz Şerit",
  "block.minecraft.banner.stripe_top.yellow": "Üstte Sarı Şerit",
  "block.minecraft.banner.triangle_bottom.black": "Altta Siyah Üçgen",
  "block.minecraft.banner.triangle_bottom.blue": "Altta Mavi Üçgen",
  "block.minecraft.banner.triangle_bottom.brown": "Altta Kahverengi Üçgen",
  "block.minecraft.banner.triangle_bottom.cyan": "Altta Camgöbeği Üçgen",
  "block.minecraft.banner.triangle_bottom.gray": "Altta Gri Üçgen",
  "block.minecraft.banner.triangle_bottom.green": "Altta Yeşil Üçgen",
  "block.minecraft.banner.triangle_bottom.light_blue": "Altta Açık Mavi Üçgen",
  "block.minecraft.banner.triangle_bottom.light_gray": "Altta Açık Gri Üçgen",
  "block.minecraft.banner.triangle_bottom.lime": "Altta Açık Yeşil Üçgen",
  "block.minecraft.banner.triangle_bottom.magenta": "Altta Eflatun Üçgen",
  "block.minecraft.banner.triangle_bottom.orange": "Altta Turuncu Üçgen",
  "block.minecraft.banner.triangle_bottom.pink": "Altta Pembe Üçgen",
  "block.minecraft.banner.triangle_bottom.purple": "Altta Mor Üçgen",
  "block.minecraft.banner.triangle_bottom.red": "Altta Kırmızı Üçgen",
  "block.minecraft.banner.triangle_bottom.white": "Altta Beyaz Üçgen",
  "block.minecraft.banner.triangle_bottom.yellow": "Altta Sarı Üçgen",
  "block.minecraft.banner.triangle_top.black": "Üstte Siyah Üçgen",
  "block.minecraft.banner.triangle_top.blue": "Üstte Mavi Üçgen",
  "block.minecraft.banner.triangle_top.brown": "Üstte Kahverengi Üçgen",
  "block.minecraft.banner.triangle_top.cyan": "Üstte Camgöbeği Üçgen",
  "block.minecraft.banner.triangle_top.gray": "Üstte Gri Üçgen",
  "block.minecraft.banner.triangle_top.green": "Üstte Yeşil Üçgen",
  "block.minecraft.banner.triangle_top.light_blue": "Üstte Açık Mavi Üçgen",
  "block.minecraft.banner.triangle_top.light_gray": "Üstte Açık Gri Üçgen",
  "block.minecraft.banner.triangle_top.lime": "Üstte Açık Yeşil Üçgen",
  "block.minecraft.banner.triangle_top.magenta": "Üstte Eflatun Üçgen",
  "block.minecraft.banner.triangle_top.orange": "Üstte Turuncu Üçgen",
  "block.minecraft.banner.triangle_top.pink": "Üstte Pembe Üçgen",
  "block.minecraft.banner.triangle_top.purple": "Üstte Mor Üçgen",
  "block.minecraft.banner.triangle_top.red": "Üstte Kırmızı Üçgen",
  "block.minecraft.banner.triangle_top.white": "Üstte Beyaz Üçgen",
  "block.minecraft.banner.triangle_top.yellow": "Üstte Sarı Üçgen",
  "block.minecraft.banner.triangles_bottom.black": "Altta Siyah Testere Dişi",
  "block.minecraft.banner.triangles_bottom.blue": "Altta Mavi Testere Dişi",
  "block.minecraft.banner.triangles_bottom.brown": "Altta Kahverengi Testere Dişi",
  "block.minecraft.banner.triangles_bottom.cyan": "Altta Camgöbeği Testere Dişi",
  "block.minecraft.banner.triangles_bottom.gray": "Altta Gri Testere Dişi",
  "block.minecraft.banner.triangles_bottom.green": "Altta Yeşil Testere Dişi",
  "block.minecraft.banner.triangles_bottom.light_blue": "Altta Açık Mavi Testere Dişi",
  "block.minecraft.banner.triangles_bottom.light_gray": "Altta Açık Gri Testere Dişi",
  "block.minecraft.banner.triangles_bottom.lime": "Altta Açık Yeşil Testere Dişi",
  "block.minecraft.banner.triangles_bottom.magenta": "Altta Eflatun Testere Dişi",
  "block.minecraft.banner.triangles_bottom.orange": "Altta Turuncu Testere Dişi",
  "block.minecraft.banner.triangles_bottom.pink": "Altta Pembe Testere Dişi",
  "block.minecraft.banner.triangles_bottom.purple": "Altta Mor Testere Dişi",
  "block.minecraft.banner.triangles_bottom.red": "Altta Kırmızı Testere Dişi",
  "block.minecraft.banner.triangles_bottom.white": "Altta Beyaz Testere Dişi",
  "block.minecraft.banner.triangles_bottom.yellow": "Altta Sarı Testere Dişi",
  "block.minecraft.banner.triangles_top.black": "Üstte Siyah Testere Dişi",
  "block.minecraft.banner.triangles_top.blue": "Üstte Mavi Testere Dişi",
  "block.minecraft.banner.triangles_top.brown": "Üstte Kahverengi Testere Dişi",
  "block.minecraft.banner.triangles_top.cyan": "Üstte Camgöbeği Testere Dişi",
  "block.minecraft.banner.triangles_top.gray": "Üstte Gri Testere Dişi",
  "block.minecraft.banner.triangles_top.green": "Üstte Yeşil Testere Dişi",
  "block.minecraft.banner.triangles_top.light_blue": "Üstte Açık Mavi Testere Dişi",
  "block.minecraft.banner.triangles_top.light_gray": "Üstte Açık Gri Testere Dişi",
  "block.minecraft.banner.triangles_top.lime": "Üstte Açık Yeşil Testere Dişi",
  "block.minecraft.banner.triangles_top.magenta": "Üstte Eflatun Testere Dişi",
  "block.minecraft.banner.triangles_top.orange": "Üstte Turuncu Testere Dişi",
  "block.minecraft.banner.triangles_top.pink": "Üstte Pembe Testere Dişi",
  "block.minecraft.banner.triangles_top.purple": "Üstte Mor Testere Dişi",
  "block.minecraft.banner.triangles_top.red": "Üstte Kırmızı Testere Dişi",
  "block.minecraft.banner.triangles_top.white": "Üstte Beyaz Testere Dişi",
  "block.minecraft.banner.triangles_top.yellow": "Üstte Sarı Testere Dişi",
  "block.minecraft.barrel": "Fıçı",
  "block.minecraft.barrier": "Bariyer",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Fener",
  "block.minecraft.beacon.primary": "Birincil güç",
  "block.minecraft.beacon.secondary": "İkincil güç",
  "block.minecraft.bed.no_sleep": "Sadece geceleri veya fırtınalı havalarda uyuyabilirsin",
  "block.minecraft.bed.not_safe": "Şu an yatamazsınız, yakınınızda canavarlar var",
  "block.minecraft.bed.obstructed": "Bu yatak sıkışmış",
  "block.minecraft.bed.occupied": "Bu yatak dolu",
  "block.minecraft.bed.too_far_away": "Şu an yatamazsınız, yatak çok uzakta",
  "block.minecraft.bedrock": "Katman Kayası",
  "block.minecraft.bee_nest": "Arı Yuvası",
  "block.minecraft.beehive": "Arı Kovanı",
  "block.minecraft.beetroots": "Pancarlar",
  "block.minecraft.bell": "Çan",
  "block.minecraft.big_dripleaf": "Büyük Damla Yaprağı",
  "block.minecraft.big_dripleaf_stem": "Büyük Damla Yaprağı Kökü",
  "block.minecraft.birch_button": "Huş Düğme",
  "block.minecraft.birch_door": "Huş Kapı",
  "block.minecraft.birch_fence": "Huş Çit",
  "block.minecraft.birch_fence_gate": "Huş Çit Kapısı",
  "block.minecraft.birch_hanging_sign": "Asılı Huş Tabela",
  "block.minecraft.birch_leaves": "Huş Yaprakları",
  "block.minecraft.birch_log": "Huş Kütüğü",
  "block.minecraft.birch_planks": "Huş Tahtası",
  "block.minecraft.birch_pressure_plate": "Huş Basınç Plakası",
  "block.minecraft.birch_sapling": "Huş Fidanı",
  "block.minecraft.birch_shelf": "Huş Raf",
  "block.minecraft.birch_sign": "Huş Tabela",
  "block.minecraft.birch_slab": "Huş Basamak",
  "block.minecraft.birch_stairs": "Huş Merdiven",
  "block.minecraft.birch_trapdoor": "Huş Tuzak Kapısı",
  "block.minecraft.birch_wall_hanging_sign": "Asılı Huş Duvar Tabelası",
  "block.minecraft.birch_wall_sign": "Huş Duvar Tabelası",
  "block.minecraft.birch_wood": "Huş Odunu",
  "block.minecraft.black_banner": "Siyah Sancak",
  "block.minecraft.black_bed": "Siyah Yatak",
  "block.minecraft.black_candle": "Siyah Mum",
  "block.minecraft.black_candle_cake": "Siyah Mumlu Pasta",
  "block.minecraft.black_carpet": "Siyah Halı",
  "block.minecraft.black_concrete": "Siyah Beton",
  "block.minecraft.black_concrete_powder": "Siyah Çimento",
  "block.minecraft.black_glazed_terracotta": "Sırlanmış Siyah Terakota",
  "block.minecraft.black_shulker_box": "Siyah Shulker Kutusu",
  "block.minecraft.black_stained_glass": "Siyah Boyalı Cam",
  "block.minecraft.black_stained_glass_pane": "Siyah Boyalı İnce Cam",
  "block.minecraft.black_terracotta": "Siyah Terakota",
  "block.minecraft.black_wool": "Siyah Yün",
  "block.minecraft.blackstone": "Kara Taş",
  "block.minecraft.blackstone_slab": "Kara Taş Basamak",
  "block.minecraft.blackstone_stairs": "Kara Taş Merdiven",
  "block.minecraft.blackstone_wall": "Kara Taş Duvar",
  "block.minecraft.blast_furnace": "Maden Eritme Ocağı",
  "block.minecraft.blue_banner": "Mavi Sancak",
  "block.minecraft.blue_bed": "Mavi Yatak",
  "block.minecraft.blue_candle": "Mavi Mum",
  "block.minecraft.blue_candle_cake": "Mavi Mumlu Pasta",
  "block.minecraft.blue_carpet": "Mavi Halı",
  "block.minecraft.blue_concrete": "Mavi Beton",
  "block.minecraft.blue_concrete_powder": "Mavi Çimento",
  "block.minecraft.blue_glazed_terracotta": "Sırlanmış Mavi Terakota",
  "block.minecraft.blue_ice": "Mavi Buz",
  "block.minecraft.blue_orchid": "Mavi Orkide",
  "block.minecraft.blue_shulker_box": "Mavi Shulker Kutusu",
  "block.minecraft.blue_stained_glass": "Mavi Boyalı Cam",
  "block.minecraft.blue_stained_glass_pane": "Mavi Boyalı İnce Cam",
  "block.minecraft.blue_terracotta": "Mavi Terakota",
  "block.minecraft.blue_wool": "Mavi Yün",
  "block.minecraft.bone_block": "Kemik Bloğu",
  "block.minecraft.bookshelf": "Kitaplık",
  "block.minecraft.brain_coral": "Beyin Mercanı",
  "block.minecraft.brain_coral_block": "Beyin Mercanı Bloğu",
  "block.minecraft.brain_coral_fan": "Beyin Yelpaze Mercanı",
  "block.minecraft.brain_coral_wall_fan": "Duvarda Beyin Yelpaze Mercanı",
  "block.minecraft.brewing_stand": "İksir Tezgâhı",
  "block.minecraft.brick_slab": "Tuğla Basamak",
  "block.minecraft.brick_stairs": "Tuğla Merdiven",
  "block.minecraft.brick_wall": "Tuğla Duvar",
  "block.minecraft.bricks": "Tuğla",
  "block.minecraft.brown_banner": "Kahverengi Sancak",
  "block.minecraft.brown_bed": "Kahverengi Yatak",
  "block.minecraft.brown_candle": "Kahverengi Mum",
  "block.minecraft.brown_candle_cake": "Kahverengi Mumlu Pasta",
  "block.minecraft.brown_carpet": "Kahverengi Halı",
  "block.minecraft.brown_concrete": "Kahverengi Beton",
  "block.minecraft.brown_concrete_powder": "Kahverengi Çimento",
  "block.minecraft.brown_glazed_terracotta": "Sırlanmış Kahverengi Terakota",
  "block.minecraft.brown_mushroom": "Kahverengi Mantar",
  "block.minecraft.brown_mushroom_block": "Kahverengi Mantar Bloğu",
  "block.minecraft.brown_shulker_box": "Kahverengi Shulker Kutusu",
  "block.minecraft.brown_stained_glass": "Kahverengi Boyalı Cam",
  "block.minecraft.brown_stained_glass_pane": "Kahverengi Boyalı İnce Cam",
  "block.minecraft.brown_terracotta": "Kahverengi Terakota",
  "block.minecraft.brown_wool": "Kahverengi Yün",
  "block.minecraft.bubble_column": "Kabarcık Sütunu",
  "block.minecraft.bubble_coral": "Baloncuk Mercanı",
  "block.minecraft.bubble_coral_block": "Baloncuk Mercanı Bloğu",
  "block.minecraft.bubble_coral_fan": "Baloncuk Yelpaze Mercanı",
  "block.minecraft.bubble_coral_wall_fan": "Duvarda Baloncuk Yelpaze Mercanı",
  "block.minecraft.budding_amethyst": "Tomurcuklanan Ametist",
  "block.minecraft.bush": "Çalı",
  "block.minecraft.cactus": "Kaktüs",
  "block.minecraft.cactus_flower": "Kaktüs Çiçeği",
  "block.minecraft.cake": "Pasta",
  "block.minecraft.calcite": "Kireç Taşı",
  "block.minecraft.calibrated_sculk_sensor": "Ayarlanmış Sculk Sensörü",
  "block.minecraft.campfire": "Kamp Ateşi",
  "block.minecraft.candle": "Mum",
  "block.minecraft.candle_cake": "Mumlu Pasta",
  "block.minecraft.carrots": "Havuçlar",
  "block.minecraft.cartography_table": "Haritacı Masası",
  "block.minecraft.carved_pumpkin": "Yontulmuş Bal Kabağı",
  "block.minecraft.cauldron": "Kazan",
  "block.minecraft.cave_air": "Mağara Havası",
  "block.minecraft.cave_vines": "Mağara Sarmaşığı",
  "block.minecraft.cave_vines_plant": "Mağara Sarmaşığı Bitkisi",
  "block.minecraft.chain": "Zincir",
  "block.minecraft.chain_command_block": "Zincirleme Komut Bloğu",
  "block.minecraft.cherry_button": "Kiraz Ağacı Düğme",
  "block.minecraft.cherry_door": "Kiraz Ağacı Kapı",
  "block.minecraft.cherry_fence": "Kiraz Ağacı Çit",
  "block.minecraft.cherry_fence_gate": "Kiraz Ağacı Çit Kapısı",
  "block.minecraft.cherry_hanging_sign": "Asılı Kiraz Ağacı Tabela",
  "block.minecraft.cherry_leaves": "Kiraz Ağacı Yaprakları",
  "block.minecraft.cherry_log": "Kiraz Ağacı Kütüğü",
  "block.minecraft.cherry_planks": "Kiraz Ağacı Tahta",
  "block.minecraft.cherry_pressure_plate": "Kiraz Ağacı Basınç Plakası",
  "block.minecraft.cherry_sapling": "Kiraz Ağacı Fidanı",
  "block.minecraft.cherry_shelf": "Kiraz Ağacı Raf",
  "block.minecraft.cherry_sign": "Kiraz Ağacı Tabela",
  "block.minecraft.cherry_slab": "Kiraz Ağacı Basamak",
  "block.minecraft.cherry_stairs": "Kiraz Ağacı Merdiven",
  "block.minecraft.cherry_trapdoor": "Kiraz Ağacı Tuzak Kapısı",
  "block.minecraft.cherry_wall_hanging_sign": "Asılı Kiraz Ağacı Duvar Tabelası",
  "block.minecraft.cherry_wall_sign": "Kiraz Ağacı Duvar Tabelası",
  "block.minecraft.cherry_wood": "Kiraz Ağacı Odunu",
  "block.minecraft.chest": "Sandık",
  "block.minecraft.chipped_anvil": "Çizilmiş Örs",
  "block.minecraft.chiseled_bookshelf": "Yontulmuş Kitaplık",
  "block.minecraft.chiseled_copper": "Yontulmuş Bakır",
  "block.minecraft.chiseled_deepslate": "Yontulmuş Kayrak Taşı",
  "block.minecraft.chiseled_nether_bricks": "Yontulmuş Nether Tuğlası",
  "block.minecraft.chiseled_polished_blackstone": "Yontulmuş Cilalı Kara Taş",
  "block.minecraft.chiseled_quartz_block": "Yontulmuş Kuvars Bloğu",
  "block.minecraft.chiseled_red_sandstone": "Yontulmuş Kırmızı Kum Taşı",
  "block.minecraft.chiseled_resin_bricks": "Yontulmuş Reçine Tuğla",
  "block.minecraft.chiseled_sandstone": "Yontulmuş Kum Taşı",
  "block.minecraft.chiseled_stone_bricks": "Yontulmuş Taş Tuğlası",
  "block.minecraft.chiseled_tuff": "Yontulmuş Tüf",
  "block.minecraft.chiseled_tuff_bricks": "Yontulmuş Tüf Tuğla",
  "block.minecraft.chorus_flower": "Nakarat Çiçeği",
  "block.minecraft.chorus_plant": "Nakarat Bitkisi",
  "block.minecraft.clay": "Kil",
  "block.minecraft.closed_eyeblossom": "Kapalı Göz Çiçeği",
  "block.minecraft.coal_block": "Kömür Bloğu",
  "block.minecraft.coal_ore": "Kömür Cevheri",
  "block.minecraft.coarse_dirt": "İri Taneli Toprak",
  "block.minecraft.cobbled_deepslate": "Kırık Kayrak Taşı",
  "block.minecraft.cobbled_deepslate_slab": "Kırık Kayrak Taşı Basamak",
  "block.minecraft.cobbled_deepslate_stairs": "Kırık Kayrak Taşı Merdiven",
  "block.minecraft.cobbled_deepslate_wall": "Kırık Kayrak Taşı Duvar",
  "block.minecraft.cobblestone": "Kırık Taş",
  "block.minecraft.cobblestone_slab": "Kırık Taş Basamak",
  "block.minecraft.cobblestone_stairs": "Kırık Taş Merdiven",
  "block.minecraft.cobblestone_wall": "Kırık Taş Duvar",
  "block.minecraft.cobweb": "Örümcek Ağı",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Komut Bloğu",
  "block.minecraft.comparator": "Redstone Karşılaştırıcı",
  "block.minecraft.composter": "Gübre Varili",
  "block.minecraft.conduit": "Oluk",
  "block.minecraft.copper_bars": "Bakır Parmaklık",
  "block.minecraft.copper_block": "Bakır Bloğu",
  "block.minecraft.copper_bulb": "Bakır Ampul",
  "block.minecraft.copper_chain": "Bakır Zincir",
  "block.minecraft.copper_chest": "Bakır Sandık",
  "block.minecraft.copper_door": "Bakır Kapı",
  "block.minecraft.copper_golem_statue": "Bakır Golem Heykeli",
  "block.minecraft.copper_grate": "Bakır Izgara",
  "block.minecraft.copper_lantern": "Bakır Fener",
  "block.minecraft.copper_ore": "Bakır Cevheri",
  "block.minecraft.copper_torch": "Bakır Meşale",
  "block.minecraft.copper_trapdoor": "Bakır Tuzak Kapısı",
  "block.minecraft.copper_wall_torch": "Duvarda Bakır Meşale",
  "block.minecraft.cornflower": "Mavi Peygamber Çiçeği",
  "block.minecraft.cracked_deepslate_bricks": "Çatlak Kayrak Taşı Tuğlası",
  "block.minecraft.cracked_deepslate_tiles": "Çatlak Döşeme Kayrak Taşı",
  "block.minecraft.cracked_nether_bricks": "Çatlak Nether Tuğlası",
  "block.minecraft.cracked_polished_blackstone_bricks": "Çatlak Cilalı Kara Taş Tuğlası",
  "block.minecraft.cracked_stone_bricks": "Çatlak Taş Tuğlası",
  "block.minecraft.crafter": "Üretici",
  "block.minecraft.crafting_table": "Çalışma Masası",
  "block.minecraft.creaking_heart": "Gıcırtı Kalbi",
  "block.minecraft.creeper_head": "Creeper Kafası",
  "block.minecraft.creeper_wall_head": "Duvarda Creeper Kafası",
  "block.minecraft.crimson_button": "Kızıl Düğme",
  "block.minecraft.crimson_door": "Kızıl Kapı",
  "block.minecraft.crimson_fence": "Kızıl Çit",
  "block.minecraft.crimson_fence_gate": "Kızıl Çit Kapısı",
  "block.minecraft.crimson_fungus": "Kızıl Mantar",
  "block.minecraft.crimson_hanging_sign": "Asılı Kızıl Tabela",
  "block.minecraft.crimson_hyphae": "Kızıl Hif",
  "block.minecraft.crimson_nylium": "Kızıl Niselyum",
  "block.minecraft.crimson_planks": "Kızıl Tahta",
  "block.minecraft.crimson_pressure_plate": "Kızıl Basınç Plakası",
  "block.minecraft.crimson_roots": "Kızıl Kökler",
  "block.minecraft.crimson_shelf": "Kızıl Raf",
  "block.minecraft.crimson_sign": "Kızıl Tabela",
  "block.minecraft.crimson_slab": "Kızıl Basamak",
  "block.minecraft.crimson_stairs": "Kızıl Merdiven",
  "block.minecraft.crimson_stem": "Kızıl Kök",
  "block.minecraft.crimson_trapdoor": "Kızıl Tuzak Kapısı",
  "block.minecraft.crimson_wall_hanging_sign": "Asılı Kızıl Duvar Tabelası",
  "block.minecraft.crimson_wall_sign": "Kızıl Duvar Tabelası",
  "block.minecraft.crying_obsidian": "Ağlayan Obsidiyen",
  "block.minecraft.cut_copper": "Kesilmiş Bakır",
  "block.minecraft.cut_copper_slab": "Kesilmiş Bakır Basamak",
  "block.minecraft.cut_copper_stairs": "Kesilmiş Bakır Merdiven",
  "block.minecraft.cut_red_sandstone": "Kesilmiş Kırmızı Kum Taşı",
  "block.minecraft.cut_red_sandstone_slab": "Kesilmiş Kırmızı Kum Taşı Basamak",
  "block.minecraft.cut_sandstone": "Kesilmiş Kum Taşı",
  "block.minecraft.cut_sandstone_slab": "Kesilmiş Kum Taşı Basamak",
  "block.minecraft.cyan_banner": "Camgöbeği Sancak",
  "block.minecraft.cyan_bed": "Camgöbeği Yatak",
  "block.minecraft.cyan_candle": "Camgöbeği Mum",
  "block.minecraft.cyan_candle_cake": "Camgöbeği Mumlu Pasta",
  "block.minecraft.cyan_carpet": "Camgöbeği Halı",
  "block.minecraft.cyan_concrete": "Camgöbeği Beton",
  "block.minecraft.cyan_concrete_powder": "Camgöbeği Çimento",
  "block.minecraft.cyan_glazed_terracotta": "Sırlanmış Camgöbeği Terakota",
  "block.minecraft.cyan_shulker_box": "Camgöbeği Shulker Kutusu",
  "block.minecraft.cyan_stained_glass": "Camgöbeği Boyalı Cam",
  "block.minecraft.cyan_stained_glass_pane": "Camgöbeği Boyalı İnce Cam",
  "block.minecraft.cyan_terracotta": "Camgöbeği Terakota",
  "block.minecraft.cyan_wool": "Camgöbeği Yün",
  "block.minecraft.damaged_anvil": "Hasarlı Örs",
  "block.minecraft.dandelion": "Karahindiba",
  "block.minecraft.dark_oak_button": "Koyu Meşe Düğme",
  "block.minecraft.dark_oak_door": "Koyu Meşe Kapı",
  "block.minecraft.dark_oak_fence": "Koyu Meşe Çit",
  "block.minecraft.dark_oak_fence_gate": "Koyu Meşe Çit Kapısı",
  "block.minecraft.dark_oak_hanging_sign": "Asılı Koyu Meşe Tabela",
  "block.minecraft.dark_oak_leaves": "Koyu Meşe Yaprakları",
  "block.minecraft.dark_oak_log": "Koyu Meşe Kütüğü",
  "block.minecraft.dark_oak_planks": "Koyu Meşe Tahtası",
  "block.minecraft.dark_oak_pressure_plate": "Koyu Meşe Basınç Plakası",
  "block.minecraft.dark_oak_sapling": "Koyu Meşe Fidanı",
  "block.minecraft.dark_oak_shelf": "Koyu Meşe Raf",
  "block.minecraft.dark_oak_sign": "Koyu Meşe Tabela",
  "block.minecraft.dark_oak_slab": "Koyu Meşe Basamak",
  "block.minecraft.dark_oak_stairs": "Koyu Meşe Merdiven",
  "block.minecraft.dark_oak_trapdoor": "Koyu Meşe Tuzak Kapısı",
  "block.minecraft.dark_oak_wall_hanging_sign": "Asılı Koyu Meşe Duvar Tabelası",
  "block.minecraft.dark_oak_wall_sign": "Koyu Meşe Duvar Tabelası",
  "block.minecraft.dark_oak_wood": "Koyu Meşe Odunu",
  "block.minecraft.dark_prismarine": "Koyu Prizmarin",
  "block.minecraft.dark_prismarine_slab": "Koyu Prizmarin Basamak",
  "block.minecraft.dark_prismarine_stairs": "Koyu Prizmarin Merdiven",
  "block.minecraft.daylight_detector": "Gün Işığı Algılayıcısı",
  "block.minecraft.dead_brain_coral": "Ölü Beyin Mercanı",
  "block.minecraft.dead_brain_coral_block": "Ölü Beyin Mercanı Bloğu",
  "block.minecraft.dead_brain_coral_fan": "Ölü Beyin Yelpaze Mercanı",
  "block.minecraft.dead_brain_coral_wall_fan": "Duvarda Ölü Beyin Yelpaze Mercanı",
  "block.minecraft.dead_bubble_coral": "Ölü Baloncuk Mercanı",
  "block.minecraft.dead_bubble_coral_block": "Ölü Baloncuk Mercanı Bloğu",
  "block.minecraft.dead_bubble_coral_fan": "Ölü Baloncuk Yelpaze Mercanı",
  "block.minecraft.dead_bubble_coral_wall_fan": "Duvarda Ölü Baloncuk Yelpaze Mercanı",
  "block.minecraft.dead_bush": "Ölü Çalı",
  "block.minecraft.dead_fire_coral": "Ölü Ateş Mercanı",
  "block.minecraft.dead_fire_coral_block": "Ölü Ateş Mercanı Bloğu",
  "block.minecraft.dead_fire_coral_fan": "Ölü Ateş Yelpaze Mercanı",
  "block.minecraft.dead_fire_coral_wall_fan": "Duvarda Ölü Ateş Yelpaze Mercanı",
  "block.minecraft.dead_horn_coral": "Ölü Boynuz Mercanı",
  "block.minecraft.dead_horn_coral_block": "Ölü Boynuz Mercanı Bloğu",
  "block.minecraft.dead_horn_coral_fan": "Ölü Boynuz Yelpaze Mercanı",
  "block.minecraft.dead_horn_coral_wall_fan": "Duvarda Ölü Boynuz Yelpaze Mercanı",
  "block.minecraft.dead_tube_coral": "Ölü Tüp Mercanı",
  "block.minecraft.dead_tube_coral_block": "Ölü Tüp Mercanı Bloğu",
  "block.minecraft.dead_tube_coral_fan": "Ölü Tüp Yelpaze Mercanı",
  "block.minecraft.dead_tube_coral_wall_fan": "Duvarda Ölü Tüp Yelpaze Mercanı",
  "block.minecraft.decorated_pot": "Süslü Çömlek",
  "block.minecraft.deepslate": "Kayrak Taşı",
  "block.minecraft.deepslate_brick_slab": "Kayrak Taşı Tuğlası Basamak",
  "block.minecraft.deepslate_brick_stairs": "Kayrak Taşı Tuğlası Merdiven",
  "block.minecraft.deepslate_brick_wall": "Kayrak Taşı Tuğlası Duvar",
  "block.minecraft.deepslate_bricks": "Kayrak Taşı Tuğlası",
  "block.minecraft.deepslate_coal_ore": "Kayrak Taşında Kömür Cevheri",
  "block.minecraft.deepslate_copper_ore": "Kayrak Taşında Bakır Cevheri",
  "block.minecraft.deepslate_diamond_ore": "Kayrak Taşında Elmas Cevheri",
  "block.minecraft.deepslate_emerald_ore": "Kayrak Taşında Zümrüt Cevheri",
  "block.minecraft.deepslate_gold_ore": "Kayrak Taşında Altın Cevheri",
  "block.minecraft.deepslate_iron_ore": "Kayrak Taşında Demir Cevheri",
  "block.minecraft.deepslate_lapis_ore": "Kayrak Taşında Lapis Lazuli Cevheri",
  "block.minecraft.deepslate_redstone_ore": "Kayrak Taşında Redstone Cevheri",
  "block.minecraft.deepslate_tile_slab": "Döşeme Kayrak Taşı Basamak",
  "block.minecraft.deepslate_tile_stairs": "Döşeme Kayrak Taşı Merdiven",
  "block.minecraft.deepslate_tile_wall": "Döşeme Kayrak Taşı Duvar",
  "block.minecraft.deepslate_tiles": "Döşeme Kayrak Taşı",
  "block.minecraft.detector_rail": "Algılayıcı Ray",
  "block.minecraft.diamond_block": "Elmas Bloğu",
  "block.minecraft.diamond_ore": "Elmas Cevheri",
  "block.minecraft.diorite": "Diyorit",
  "block.minecraft.diorite_slab": "Diyorit Basamak",
  "block.minecraft.diorite_stairs": "Diyorit Merdiven",
  "block.minecraft.diorite_wall": "Diyorit Duvar",
  "block.minecraft.dirt": "Toprak",
  "block.minecraft.dirt_path": "Toprak Yol",
  "block.minecraft.dispenser": "Fırlatıcı",
  "block.minecraft.dragon_egg": "Ejderha Yumurtası",
  "block.minecraft.dragon_head": "Ejderha Kafası",
  "block.minecraft.dragon_wall_head": "Duvarda Ejderha Kafası",
  "block.minecraft.dried_ghast": "Kurumuş Ghast",
  "block.minecraft.dried_kelp_block": "Kurutulmuş Su Yosunu Bloğu",
  "block.minecraft.dripstone_block": "Damla Taş Bloğu",
  "block.minecraft.dropper": "Bırakıcı",
  "block.minecraft.emerald_block": "Zümrüt Bloğu",
  "block.minecraft.emerald_ore": "Zümrüt Cevheri",
  "block.minecraft.enchanting_table": "Büyü Masası",
  "block.minecraft.end_gateway": "End Geçidi",
  "block.minecraft.end_portal": "End Geçidi",
  "block.minecraft.end_portal_frame": "End Geçidi Çerçevesi",
  "block.minecraft.end_rod": "End Çubuğu",
  "block.minecraft.end_stone": "End Taşı",
  "block.minecraft.end_stone_brick_slab": "End Taşı Tuğlası Basamak",
  "block.minecraft.end_stone_brick_stairs": "End Taşı Tuğlası Merdiven",
  "block.minecraft.end_stone_brick_wall": "End Taşı Tuğlası Duvar",
  "block.minecraft.end_stone_bricks": "End Taşı Tuğlası",
  "block.minecraft.ender_chest": "Ender Sandığı",
  "block.minecraft.exposed_chiseled_copper": "Açıkta Kalmış Yontulmuş Bakır",
  "block.minecraft.exposed_copper": "Açıkta Kalmış Bakır",
  "block.minecraft.exposed_copper_bars": "Açıkta Kalmış Bakır Parmaklık",
  "block.minecraft.exposed_copper_bulb": "Açıkta Kalmış Bakır Ampul",
  "block.minecraft.exposed_copper_chain": "Açıkta Kalmış Bakır Zincir",
  "block.minecraft.exposed_copper_chest": "Açıkta Kalmış Bakır Sandık",
  "block.minecraft.exposed_copper_door": "Açıkta Kalmış Bakır Kapı",
  "block.minecraft.exposed_copper_golem_statue": "Açıkta Kalmış Bakır Golem Heykeli",
  "block.minecraft.exposed_copper_grate": "Açıkta Kalmış Bakır Izgara",
  "block.minecraft.exposed_copper_lantern": "Açıkta Kalmış Bakır Fener",
  "block.minecraft.exposed_copper_trapdoor": "Açıkta Kalmış Bakır Tuzak Kapısı",
  "block.minecraft.exposed_cut_copper": "Açıkta Kalmış Kesilmiş Bakır",
  "block.minecraft.exposed_cut_copper_slab": "Açıkta Kalmış Kesilmiş Bakır Basamak",
  "block.minecraft.exposed_cut_copper_stairs": "Açıkta Kalmış Kesilmiş Bakır Merdiven",
  "block.minecraft.exposed_lightning_rod": "Açıkta Kalmış Paratoner",
  "block.minecraft.farmland": "Tarım Arazisi",
  "block.minecraft.fern": "Eğrelti otu",
  "block.minecraft.fire": "Ateş",
  "block.minecraft.fire_coral": "Ateş Mercanı",
  "block.minecraft.fire_coral_block": "Ateş Mercanı Bloğu",
  "block.minecraft.fire_coral_fan": "Ateş Yelpaze Mercanı",
  "block.minecraft.fire_coral_wall_fan": "Duvarda Ateş Yelpaze Mercanı",
  "block.minecraft.firefly_bush": "Ateş Böceği Çalısı",
  "block.minecraft.fletching_table": "Okçu Masası",
  "block.minecraft.flower_pot": "Saksı",
  "block.minecraft.flowering_azalea": "Çiçekli Açelya",
  "block.minecraft.flowering_azalea_leaves": "Çiçekli Açelya Yaprakları",
  "block.minecraft.frogspawn": "Kurbağa Yumurtaları",
  "block.minecraft.frosted_ice": "Kırağı",
  "block.minecraft.furnace": "Ocak",
  "block.minecraft.gilded_blackstone": "Yaldızlı Kara Taş",
  "block.minecraft.glass": "Cam",
  "block.minecraft.glass_pane": "İnce Cam",
  "block.minecraft.glow_lichen": "Parlayan Liken",
  "block.minecraft.glowstone": "Işık Taşı",
  "block.minecraft.gold_block": "Altın Bloğu",
  "block.minecraft.gold_ore": "Altın Cevheri",
  "block.minecraft.golden_dandelion": "Altın Karahindiba",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granit Basamak",
  "block.minecraft.granite_stairs": "Granit Merdiven",
  "block.minecraft.granite_wall": "Granit Duvar",
  "block.minecraft.grass": "Çimen",
  "block.minecraft.grass_block": "Çimenli Toprak",
  "block.minecraft.gravel": "Çakıl",
  "block.minecraft.gray_banner": "Gri Sancak",
  "block.minecraft.gray_bed": "Gri Yatak",
  "block.minecraft.gray_candle": "Gri Mum",
  "block.minecraft.gray_candle_cake": "Gri Mumlu Pasta",
  "block.minecraft.gray_carpet": "Gri Halı",
  "block.minecraft.gray_concrete": "Gri Beton",
  "block.minecraft.gray_concrete_powder": "Gri Çimento",
  "block.minecraft.gray_glazed_terracotta": "Sırlanmış Gri Terakota",
  "block.minecraft.gray_shulker_box": "Gri Shulker Kutusu",
  "block.minecraft.gray_stained_glass": "Gri Boyalı Cam",
  "block.minecraft.gray_stained_glass_pane": "Gri Boyalı İnce Cam",
  "block.minecraft.gray_terracotta": "Gri Terakota",
  "block.minecraft.gray_wool": "Gri Yün",
  "block.minecraft.green_banner": "Yeşil Sancak",
  "block.minecraft.green_bed": "Yeşil Yatak",
  "block.minecraft.green_candle": "Yeşil Mum",
  "block.minecraft.green_candle_cake": "Yeşil Mumlu Pasta",
  "block.minecraft.green_carpet": "Yeşil Halı",
  "block.minecraft.green_concrete": "Yeşil Beton",
  "block.minecraft.green_concrete_powder": "Yeşil Çimento",
  "block.minecraft.green_glazed_terracotta": "Sırlanmış Yeşil Terakota",
  "block.minecraft.green_shulker_box": "Yeşil Shulker Kutusu",
  "block.minecraft.green_stained_glass": "Yeşil Boyalı Cam",
  "block.minecraft.green_stained_glass_pane": "Yeşil Boyalı İnce Cam",
  "block.minecraft.green_terracotta": "Yeşil Terakota",
  "block.minecraft.green_wool": "Yeşil Yün",
  "block.minecraft.grindstone": "Bileme Taşı",
  "block.minecraft.hanging_roots": "Sarkan Kökler",
  "block.minecraft.hay_block": "Saman Balyası",
  "block.minecraft.heavy_core": "Ağır Çekirdek",
  "block.minecraft.heavy_weighted_pressure_plate": "Sert Ağırlıklı Basınç Plakası",
  "block.minecraft.honey_block": "Bal Bloğu",
  "block.minecraft.honeycomb_block": "Bal Peteği Bloğu",
  "block.minecraft.hopper": "Huni",
  "block.minecraft.horn_coral": "Boynuz Mercanı",
  "block.minecraft.horn_coral_block": "Boynuz Mercanı Bloğu",
  "block.minecraft.horn_coral_fan": "Boynuz Yelpaze Mercanı",
  "block.minecraft.horn_coral_wall_fan": "Duvarda Boynuz Yelpaze Mercanı",
  "block.minecraft.ice": "Buz",
  "block.minecraft.infested_chiseled_stone_bricks": "İstila Edilmiş Yontulmuş Taş Tuğlası",
  "block.minecraft.infested_cobblestone": "İstila Edilmiş Kırık Taş",
  "block.minecraft.infested_cracked_stone_bricks": "İstila Edilmiş Çatlak Taş Tuğlası",
  "block.minecraft.infested_deepslate": "İstila Edilmiş Kayrak Taşı",
  "block.minecraft.infested_mossy_stone_bricks": "İstila Edilmiş Yosunlu Taş Tuğlası",
  "block.minecraft.infested_stone": "İstila Edilmiş Taş",
  "block.minecraft.infested_stone_bricks": "İstila Edilmiş Taş Tuğlası",
  "block.minecraft.iron_bars": "Demir Parmaklık",
  "block.minecraft.iron_block": "Demir Bloğu",
  "block.minecraft.iron_chain": "Demir Zincir",
  "block.minecraft.iron_door": "Demir Kapı",
  "block.minecraft.iron_ore": "Demir Cevheri",
  "block.minecraft.iron_trapdoor": "Demir Tuzak Kapısı",
  "block.minecraft.jack_o_lantern": "Bal Kabağı Lambası",
  "block.minecraft.jigsaw": "Yapboz Bloğu",
  "block.minecraft.jukebox": "Müzik Kutusu",
  "block.minecraft.jungle_button": "Orman Ağacı Düğme",
  "block.minecraft.jungle_door": "Orman Ağacı Kapı",
  "block.minecraft.jungle_fence": "Orman Ağacı Çit",
  "block.minecraft.jungle_fence_gate": "Orman Ağacı Çit Kapısı",
  "block.minecraft.jungle_hanging_sign": "Asılı Orman Ağacı Tabela",
  "block.minecraft.jungle_leaves": "Orman Ağacı Yaprakları",
  "block.minecraft.jungle_log": "Orman Ağacı Kütüğü",
  "block.minecraft.jungle_planks": "Orman Ağacı Tahtası",
  "block.minecraft.jungle_pressure_plate": "Orman Ağacı Basınç Plakası",
  "block.minecraft.jungle_sapling": "Orman Ağacı Fidanı",
  "block.minecraft.jungle_shelf": "Orman Ağacı Raf",
  "block.minecraft.jungle_sign": "Orman Ağacı Tabela",
  "block.minecraft.jungle_slab": "Orman Ağacı Basamak",
  "block.minecraft.jungle_stairs": "Orman Ağacı Merdiven",
  "block.minecraft.jungle_trapdoor": "Orman Ağacı Tuzak Kapısı",
  "block.minecraft.jungle_wall_hanging_sign": "Asılı Orman Ağacı Duvar Tabelası",
  "block.minecraft.jungle_wall_sign": "Orman Ağacı Duvar Tabelası",
  "block.minecraft.jungle_wood": "Orman Ağacı Odunu",
  "block.minecraft.kelp": "Su Yosunu",
  "block.minecraft.kelp_plant": "Su Yosunu",
  "block.minecraft.ladder": "Merdiven",
  "block.minecraft.lantern": "Fener",
  "block.minecraft.lapis_block": "Lapis Lazuli Bloğu",
  "block.minecraft.lapis_ore": "Lapis Lazuli Cevheri",
  "block.minecraft.large_amethyst_bud": "Büyük Ametist Tomurcuğu",
  "block.minecraft.large_fern": "Büyük Eğrelti Otu",
  "block.minecraft.lava": "Lav",
  "block.minecraft.lava_cauldron": "Lav Kazanı",
  "block.minecraft.leaf_litter": "Kuru Yapraklar",
  "block.minecraft.lectern": "Kürsü",
  "block.minecraft.lever": "Şalter",
  "block.minecraft.light": "Işık",
  "block.minecraft.light_blue_banner": "Açık Mavi Sancak",
  "block.minecraft.light_blue_bed": "Açık Mavi Yatak",
  "block.minecraft.light_blue_candle": "Açık Mavi Mum",
  "block.minecraft.light_blue_candle_cake": "Açık Mavi Mumlu Pasta",
  "block.minecraft.light_blue_carpet": "Açık Mavi Halı",
  "block.minecraft.light_blue_concrete": "Açık Mavi Beton",
  "block.minecraft.light_blue_concrete_powder": "Açık Mavi Çimento",
  "block.minecraft.light_blue_glazed_terracotta": "Sırlanmış Açık Mavi Terakota",
  "block.minecraft.light_blue_shulker_box": "Açık Mavi Shulker Kutusu",
  "block.minecraft.light_blue_stained_glass": "Açık Mavi Boyalı Cam",
  "block.minecraft.light_blue_stained_glass_pane": "Açık Mavi Boyalı İnce Cam",
  "block.minecraft.light_blue_terracotta": "Açık Mavi Terakota",
  "block.minecraft.light_blue_wool": "Açık Mavi Yün",
  "block.minecraft.light_gray_banner": "Açık Gri Sancak",
  "block.minecraft.light_gray_bed": "Açık Gri Yatak",
  "block.minecraft.light_gray_candle": "Açık Gri Mum",
  "block.minecraft.light_gray_candle_cake": "Açık Gri Mumlu Pasta",
  "block.minecraft.light_gray_carpet": "Açık Gri Halı",
  "block.minecraft.light_gray_concrete": "Açık Gri Beton",
  "block.minecraft.light_gray_concrete_powder": "Açık Gri Çimento",
  "block.minecraft.light_gray_glazed_terracotta": "Sırlanmış Açık Gri Terakota",
  "block.minecraft.light_gray_shulker_box": "Açık Gri Shulker Kutusu",
  "block.minecraft.light_gray_stained_glass": "Açık Gri Boyalı Cam",
  "block.minecraft.light_gray_stained_glass_pane": "Açık Gri Boyalı İnce Cam",
  "block.minecraft.light_gray_terracotta": "Açık Gri Terakota",
  "block.minecraft.light_gray_wool": "Açık Gri Yün",
  "block.minecraft.light_weighted_pressure_plate": "Hassas Ağırlıklı Basınç Plakası",
  "block.minecraft.lightning_rod": "Paratoner",
  "block.minecraft.lilac": "Leylak",
  "block.minecraft.lily_of_the_valley": "İnci Çiçeği",
  "block.minecraft.lily_pad": "Nilüfer Yaprağı",
  "block.minecraft.lime_banner": "Açık Yeşil Sancak",
  "block.minecraft.lime_bed": "Açık Yeşil Yatak",
  "block.minecraft.lime_candle": "Açık Yeşil Mum",
  "block.minecraft.lime_candle_cake": "Açık Yeşil Mumlu Pasta",
  "block.minecraft.lime_carpet": "Açık Yeşil Halı",
  "block.minecraft.lime_concrete": "Açık Yeşil Beton",
  "block.minecraft.lime_concrete_powder": "Açık Yeşil Çimento",
  "block.minecraft.lime_glazed_terracotta": "Sırlanmış Açık Yeşil Terakota",
  "block.minecraft.lime_shulker_box": "Açık Yeşil Shulker Kutusu",
  "block.minecraft.lime_stained_glass": "Açık Yeşil Boyalı Cam",
  "block.minecraft.lime_stained_glass_pane": "Açık Yeşil Boyalı İnce Cam",
  "block.minecraft.lime_terracotta": "Açık Yeşil Terakota",
  "block.minecraft.lime_wool": "Açık Yeşil Yün",
  "block.minecraft.lodestone": "Manyetit",
  "block.minecraft.loom": "Dokuma Tezgâhı",
  "block.minecraft.magenta_banner": "Eflatun Sancak",
  "block.minecraft.magenta_bed": "Eflatun Yatak",
  "block.minecraft.magenta_candle": "Eflatun Mum",
  "block.minecraft.magenta_candle_cake": "Eflatun Mumlu Pasta",
  "block.minecraft.magenta_carpet": "Eflatun Halı",
  "block.minecraft.magenta_concrete": "Eflatun Beton",
  "block.minecraft.magenta_concrete_powder": "Eflatun Çimento",
  "block.minecraft.magenta_glazed_terracotta": "Sırlanmış Eflatun Terakota",
  "block.minecraft.magenta_shulker_box": "Eflatun Shulker Kutusu",
  "block.minecraft.magenta_stained_glass": "Eflatun Boyalı Cam",
  "block.minecraft.magenta_stained_glass_pane": "Eflatun Boyalı İnce Cam",
  "block.minecraft.magenta_terracotta": "Eflatun Terakota",
  "block.minecraft.magenta_wool": "Eflatun Yün",
  "block.minecraft.magma_block": "Magma Bloğu",
  "block.minecraft.mangrove_button": "Mangrov Düğme",
  "block.minecraft.mangrove_door": "Mangrov Kapı",
  "block.minecraft.mangrove_fence": "Mangrov Çit",
  "block.minecraft.mangrove_fence_gate": "Mangrov Çit Kapısı",
  "block.minecraft.mangrove_hanging_sign": "Asılı Mangrov Tabela",
  "block.minecraft.mangrove_leaves": "Mangrov Yaprakları",
  "block.minecraft.mangrove_log": "Mangrov Kütüğü",
  "block.minecraft.mangrove_planks": "Mangrov Tahtası",
  "block.minecraft.mangrove_pressure_plate": "Mangrov Basınç Plakası",
  "block.minecraft.mangrove_propagule": "Mangrov Tohumu",
  "block.minecraft.mangrove_roots": "Mangrov Kökleri",
  "block.minecraft.mangrove_shelf": "Mangrov Raf",
  "block.minecraft.mangrove_sign": "Mangrov Tabela",
  "block.minecraft.mangrove_slab": "Mangrov Basamak",
  "block.minecraft.mangrove_stairs": "Mangrov Merdiven",
  "block.minecraft.mangrove_trapdoor": "Mangrov Tuzak Kapısı",
  "block.minecraft.mangrove_wall_hanging_sign": "Asılı Mangrov Duvar Tabelası",
  "block.minecraft.mangrove_wall_sign": "Mangrov Duvar Tabelası",
  "block.minecraft.mangrove_wood": "Mangrov Odunu",
  "block.minecraft.medium_amethyst_bud": "Ortanca Ametist Tomurcuğu",
  "block.minecraft.melon": "Karpuz",
  "block.minecraft.melon_stem": "Karpuz Sapı",
  "block.minecraft.moss_block": "Yosun Bloğu",
  "block.minecraft.moss_carpet": "Yosun Halı",
  "block.minecraft.mossy_cobblestone": "Yosunlu Kırık Taş",
  "block.minecraft.mossy_cobblestone_slab": "Yosunlu Kırık Taş Basamak",
  "block.minecraft.mossy_cobblestone_stairs": "Yosunlu Kırık Taş Merdiven",
  "block.minecraft.mossy_cobblestone_wall": "Yosunlu Kırık Taş Duvar",
  "block.minecraft.mossy_stone_brick_slab": "Yosunlu Taş Tuğlası Basamak",
  "block.minecraft.mossy_stone_brick_stairs": "Yosunlu Taş Tuğlası Merdiven",
  "block.minecraft.mossy_stone_brick_wall": "Yosunlu Taş Tuğlası Duvar",
  "block.minecraft.mossy_stone_bricks": "Yosunlu Taş Tuğlası",
  "block.minecraft.moving_piston": "Hareket Eden Piston",
  "block.minecraft.mud": "Çamur",
  "block.minecraft.mud_brick_slab": "Kerpiç Basamak",
  "block.minecraft.mud_brick_stairs": "Kerpiç Merdiven",
  "block.minecraft.mud_brick_wall": "Kerpiç Duvar",
  "block.minecraft.mud_bricks": "Kerpiç",
  "block.minecraft.muddy_mangrove_roots": "Çamurlu Mangrov Kökleri",
  "block.minecraft.mushroom_stem": "Mantar Sapı",
  "block.minecraft.mycelium": "Miselyum",
  "block.minecraft.nether_brick_fence": "Nether Tuğlası Çit",
  "block.minecraft.nether_brick_slab": "Nether Tuğlası Basamak",
  "block.minecraft.nether_brick_stairs": "Nether Tuğlası Merdiveni",
  "block.minecraft.nether_brick_wall": "Nether Tuğlası Duvar",
  "block.minecraft.nether_bricks": "Nether Tuğlası",
  "block.minecraft.nether_gold_ore": "Nether Altın Cevheri",
  "block.minecraft.nether_portal": "Nether Geçidi",
  "block.minecraft.nether_quartz_ore": "Nether Kuvarsı Cevheri",
  "block.minecraft.nether_sprouts": "Nether Filizleri",
  "block.minecraft.nether_wart": "Nether Yumrusu",
  "block.minecraft.nether_wart_block": "Nether Yumrusu Bloğu",
  "block.minecraft.netherite_block": "Netherit Bloğu",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nota Bloğu",
  "block.minecraft.oak_button": "Meşe Düğme",
  "block.minecraft.oak_door": "Meşe Kapı",
  "block.minecraft.oak_fence": "Meşe Çit",
  "block.minecraft.oak_fence_gate": "Meşe Çit Kapısı",
  "block.minecraft.oak_hanging_sign": "Asılı Meşe Tabela",
  "block.minecraft.oak_leaves": "Meşe Yaprakları",
  "block.minecraft.oak_log": "Meşe Kütüğü",
  "block.minecraft.oak_planks": "Meşe Tahtası",
  "block.minecraft.oak_pressure_plate": "Meşe Basınç Plakası",
  "block.minecraft.oak_sapling": "Meşe Fidanı",
  "block.minecraft.oak_shelf": "Meşe Raf",
  "block.minecraft.oak_sign": "Meşe Tabela",
  "block.minecraft.oak_slab": "Meşe Basamak",
  "block.minecraft.oak_stairs": "Meşe Merdiven",
  "block.minecraft.oak_trapdoor": "Meşe Tuzak Kapısı",
  "block.minecraft.oak_wall_hanging_sign": "Asılı Meşe Duvar Tabelası",
  "block.minecraft.oak_wall_sign": "Meşe Duvar Tabelası",
  "block.minecraft.oak_wood": "Meşe Odunu",
  "block.minecraft.observer": "Gözlemci",
  "block.minecraft.obsidian": "Obsidiyen",
  "block.minecraft.ochre_froglight": "Okre Kurbağa Işığı",
  "block.minecraft.ominous_banner": "Uğursuz Sancak",
  "block.minecraft.open_eyeblossom": "Açık Göz Çiçeği",
  "block.minecraft.orange_banner": "Turuncu Sancak",
  "block.minecraft.orange_bed": "Turuncu Yatak",
  "block.minecraft.orange_candle": "Turuncu Mum",
  "block.minecraft.orange_candle_cake": "Turuncu Mumlu Pasta",
  "block.minecraft.orange_carpet": "Turuncu Halı",
  "block.minecraft.orange_concrete": "Turuncu Beton",
  "block.minecraft.orange_concrete_powder": "Turuncu Çimento",
  "block.minecraft.orange_glazed_terracotta": "Sırlanmış Turuncu Terakota",
  "block.minecraft.orange_shulker_box": "Turuncu Shulker Kutusu",
  "block.minecraft.orange_stained_glass": "Turuncu Boyalı Cam",
  "block.minecraft.orange_stained_glass_pane": "Turuncu Boyalı İnce Cam",
  "block.minecraft.orange_terracotta": "Turuncu Terakota",
  "block.minecraft.orange_tulip": "Turuncu Lale",
  "block.minecraft.orange_wool": "Turuncu Yün",
  "block.minecraft.oxeye_daisy": "Papatya",
  "block.minecraft.oxidized_chiseled_copper": "Oksitlenmiş Yontulmuş Bakır",
  "block.minecraft.oxidized_copper": "Oksitlenmiş Bakır",
  "block.minecraft.oxidized_copper_bars": "Oksitlenmiş Bakır Parmaklık",
  "block.minecraft.oxidized_copper_bulb": "Oksitlenmiş Bakır Ampul",
  "block.minecraft.oxidized_copper_chain": "Oksitlenmiş Bakır Zincir",
  "block.minecraft.oxidized_copper_chest": "Oksitlenmiş Bakır Sandık",
  "block.minecraft.oxidized_copper_door": "Oksitlenmiş Bakır Kapı",
  "block.minecraft.oxidized_copper_golem_statue": "Oksitlenmiş Bakır Golem Heykeli",
  "block.minecraft.oxidized_copper_grate": "Oksitlenmiş Bakır Izgara",
  "block.minecraft.oxidized_copper_lantern": "Oksitlenmiş Bakır Fener",
  "block.minecraft.oxidized_copper_trapdoor": "Oksitlenmiş Bakır Tuzak Kapısı",
  "block.minecraft.oxidized_cut_copper": "Oksitlenmiş Kesilmiş Bakır",
  "block.minecraft.oxidized_cut_copper_slab": "Oksitlenmiş Kesilmiş Bakır Basamak",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksitlenmiş Kesilmiş Bakır Merdiven",
  "block.minecraft.oxidized_lightning_rod": "Oksitlenmiş Paratoner",
  "block.minecraft.packed_ice": "Sert Buz",
  "block.minecraft.packed_mud": "Kerpiç",
  "block.minecraft.pale_hanging_moss": "Soluk Sarkan Yosun",
  "block.minecraft.pale_moss_block": "Soluk Yosun Bloğu",
  "block.minecraft.pale_moss_carpet": "Soluk Yosun Halı",
  "block.minecraft.pale_oak_button": "Soluk Meşe Düğme",
  "block.minecraft.pale_oak_door": "Soluk Meşe Kapı",
  "block.minecraft.pale_oak_fence": "Soluk Meşe Çit",
  "block.minecraft.pale_oak_fence_gate": "Soluk Meşe Çit Kapısı",
  "block.minecraft.pale_oak_hanging_sign": "Asılı Soluk Meşe Tabela",
  "block.minecraft.pale_oak_leaves": "Soluk Meşe Yaprakları",
  "block.minecraft.pale_oak_log": "Soluk Meşe Kütüğü",
  "block.minecraft.pale_oak_planks": "Soluk Meşe Tahtası",
  "block.minecraft.pale_oak_pressure_plate": "Soluk Meşe Basınç Plakası",
  "block.minecraft.pale_oak_sapling": "Soluk Meşe Fidanı",
  "block.minecraft.pale_oak_shelf": "Soluk Meşe Raf",
  "block.minecraft.pale_oak_sign": "Soluk Meşe Tabela",
  "block.minecraft.pale_oak_slab": "Soluk Meşe Basamak",
  "block.minecraft.pale_oak_stairs": "Soluk Meşe Merdiven",
  "block.minecraft.pale_oak_trapdoor": "Soluk Meşe Tuzak Kapısı",
  "block.minecraft.pale_oak_wall_hanging_sign": "Asılı Soluk Meşe Duvar Tabelası",
  "block.minecraft.pale_oak_wall_sign": "Soluk Meşe Duvar Tabelası",
  "block.minecraft.pale_oak_wood": "Soluk Meşe Odunu",
  "block.minecraft.pearlescent_froglight": "Sedefli Kurbağa Işığı",
  "block.minecraft.peony": "Şakayık",
  "block.minecraft.petrified_oak_slab": "Taşlaşmış Meşe Basamak",
  "block.minecraft.piglin_head": "Piglin Kafası",
  "block.minecraft.piglin_wall_head": "Duvarda Piglin Kafası",
  "block.minecraft.pink_banner": "Pembe Sancak",
  "block.minecraft.pink_bed": "Pembe Yatak",
  "block.minecraft.pink_candle": "Pembe Mum",
  "block.minecraft.pink_candle_cake": "Pembe Mumlu Pasta",
  "block.minecraft.pink_carpet": "Pembe Halı",
  "block.minecraft.pink_concrete": "Pembe Beton",
  "block.minecraft.pink_concrete_powder": "Pembe Çimento",
  "block.minecraft.pink_glazed_terracotta": "Sırlanmış Pembe Terakota",
  "block.minecraft.pink_petals": "Pembe Yapraklar",
  "block.minecraft.pink_shulker_box": "Pembe Shulker Kutusu",
  "block.minecraft.pink_stained_glass": "Pembe Boyalı Cam",
  "block.minecraft.pink_stained_glass_pane": "Pembe Boyalı İnce Cam",
  "block.minecraft.pink_terracotta": "Pembe Terakota",
  "block.minecraft.pink_tulip": "Pembe Lale",
  "block.minecraft.pink_wool": "Pembe Yün",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Piston Kafası",
  "block.minecraft.pitcher_crop": "Sürahi Ekini",
  "block.minecraft.pitcher_plant": "Sürahi Bitkisi",
  "block.minecraft.player_head": "Oyuncu Kafası",
  "block.minecraft.player_head.named": "%s Oyuncusunun Kafası",
  "block.minecraft.player_wall_head": "Duvarda Oyuncu Kafası",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Sivri Damla Taş",
  "block.minecraft.polished_andesite": "Cilalı Andezit",
  "block.minecraft.polished_andesite_slab": "Cilalı Andezit Basamak",
  "block.minecraft.polished_andesite_stairs": "Cilalı Andezit Merdiven",
  "block.minecraft.polished_basalt": "Cilalı Bazalt",
  "block.minecraft.polished_blackstone": "Cilalı Kara Taş",
  "block.minecraft.polished_blackstone_brick_slab": "Cilalı Kara Taş Tuğlası Basamak",
  "block.minecraft.polished_blackstone_brick_stairs": "Cilalı Kara Taş Tuğlası Merdiven",
  "block.minecraft.polished_blackstone_brick_wall": "Cilalı Kara Taş Tuğlası Duvar",
  "block.minecraft.polished_blackstone_bricks": "Cilalı Kara Taş Tuğlası",
  "block.minecraft.polished_blackstone_button": "Cilalı Kara Taş Düğme",
  "block.minecraft.polished_blackstone_pressure_plate": "Cilalı Kara Taş Basınç Plakası",
  "block.minecraft.polished_blackstone_slab": "Cilalı Kara Taş Basamak",
  "block.minecraft.polished_blackstone_stairs": "Cilalı Kara Taş Merdiven",
  "block.minecraft.polished_blackstone_wall": "Cilalı Kara Taş Duvar",
  "block.minecraft.polished_deepslate": "Cilalı Kayrak Taşı",
  "block.minecraft.polished_deepslate_slab": "Cilalı Kayrak Taşı Basamak",
  "block.minecraft.polished_deepslate_stairs": "Cilalı Kayrak Taşı Merdiven",
  "block.minecraft.polished_deepslate_wall": "Cilalı Kayrak Taşı Duvar",
  "block.minecraft.polished_diorite": "Cilalı Diyorit",
  "block.minecraft.polished_diorite_slab": "Cilalı Diyorit Basamak",
  "block.minecraft.polished_diorite_stairs": "Cilalı Diyorit Merdiven",
  "block.minecraft.polished_granite": "Cilalı Granit",
  "block.minecraft.polished_granite_slab": "Cilalı Granit Basamak",
  "block.minecraft.polished_granite_stairs": "Cilalı Granit Merdiven",
  "block.minecraft.polished_tuff": "Cilalı Tüf",
  "block.minecraft.polished_tuff_slab": "Cilalı Tüf Basamak",
  "block.minecraft.polished_tuff_stairs": "Cilalı Tüf Merdiven",
  "block.minecraft.polished_tuff_wall": "Cilalı Tüf Duvar",
  "block.minecraft.poppy": "Gelincik",
  "block.minecraft.potatoes": "Patatesler",
  "block.minecraft.potted_acacia_sapling": "Akasya Fidanı Saksısı",
  "block.minecraft.potted_allium": "Alyum Saksısı",
  "block.minecraft.potted_azalea_bush": "Açelya Saksısı",
  "block.minecraft.potted_azure_bluet": "Peygamber Çiçeği Saksısı",
  "block.minecraft.potted_bamboo": "Bambu Saksısı",
  "block.minecraft.potted_birch_sapling": "Huş Fidanı Saksısı",
  "block.minecraft.potted_blue_orchid": "Mavi Orkide Saksısı",
  "block.minecraft.potted_brown_mushroom": "Kahverengi Mantar Saksısı",
  "block.minecraft.potted_cactus": "Kaktüs Saksısı",
  "block.minecraft.potted_cherry_sapling": "Kiraz Çiçeği Fidanı Saksısı",
  "block.minecraft.potted_closed_eyeblossom": "Kapalı Göz Çiçeği Saksısı",
  "block.minecraft.potted_cornflower": "Mavi Peygamber Çiçeği Saksısı",
  "block.minecraft.potted_crimson_fungus": "Kızıl Mantar Saksısı",
  "block.minecraft.potted_crimson_roots": "Saksıda Kızıl Kökler",
  "block.minecraft.potted_dandelion": "Karahindiba Saksısı",
  "block.minecraft.potted_dark_oak_sapling": "Koyu Meşe Fidanı Saksısı",
  "block.minecraft.potted_dead_bush": "Ölü Çalı Saksısı",
  "block.minecraft.potted_fern": "Eğrelti Otu Saksısı",
  "block.minecraft.potted_flowering_azalea_bush": "Çiçekli Açelya Saksısı",
  "block.minecraft.potted_golden_dandelion": "Altın Karahindiba Saksısı",
  "block.minecraft.potted_jungle_sapling": "Orman Ağacı Fidanı Saksısı",
  "block.minecraft.potted_lily_of_the_valley": "İnci Çiçeği Saksısı",
  "block.minecraft.potted_mangrove_propagule": "Mangrov Tohumu Saksısı",
  "block.minecraft.potted_oak_sapling": "Meşe Fidanı Saksısı",
  "block.minecraft.potted_open_eyeblossom": "Açık Göz Çiçeği Saksısı",
  "block.minecraft.potted_orange_tulip": "Turuncu Lale Saksısı",
  "block.minecraft.potted_oxeye_daisy": "Papatya Saksısı",
  "block.minecraft.potted_pale_oak_sapling": "Soluk Meşe Fidanı Saksısı",
  "block.minecraft.potted_pink_tulip": "Pembe Lale Saksısı",
  "block.minecraft.potted_poppy": "Gelincik Saksısı",
  "block.minecraft.potted_red_mushroom": "Kırmızı Mantar Saksısı",
  "block.minecraft.potted_red_tulip": "Kırmızı Lale Saksısı",
  "block.minecraft.potted_spruce_sapling": "Ladin Fidanı Saksısı",
  "block.minecraft.potted_torchflower": "Meşale Çiçeği Saksısı",
  "block.minecraft.potted_warped_fungus": "Çarpık Mantar Saksısı",
  "block.minecraft.potted_warped_roots": "Çarpık Kök Saksısı",
  "block.minecraft.potted_white_tulip": "Beyaz Lale Saksısı",
  "block.minecraft.potted_wither_rose": "Wither Gülü Saksısı",
  "block.minecraft.powder_snow": "Tozlaşmış Kar",
  "block.minecraft.powder_snow_cauldron": "Tozlaşmış Kar Kazanı",
  "block.minecraft.powered_rail": "Elektrikli Ray",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Prizmarin Tuğlası Basamak",
  "block.minecraft.prismarine_brick_stairs": "Prizmarin Tuğlası Merdiven",
  "block.minecraft.prismarine_bricks": "Prizmarin Tuğlası",
  "block.minecraft.prismarine_slab": "Prizmarin Basamak",
  "block.minecraft.prismarine_stairs": "Prizmarin Merdiven",
  "block.minecraft.prismarine_wall": "Prizmarin Duvar",
  "block.minecraft.pumpkin": "Bal Kabağı",
  "block.minecraft.pumpkin_stem": "Bal Kabağı Sapı",
  "block.minecraft.purple_banner": "Mor Sancak",
  "block.minecraft.purple_bed": "Mor Yatak",
  "block.minecraft.purple_candle": "Mor Mum",
  "block.minecraft.purple_candle_cake": "Mor Mumlu Pasta",
  "block.minecraft.purple_carpet": "Mor Halı",
  "block.minecraft.purple_concrete": "Mor Beton",
  "block.minecraft.purple_concrete_powder": "Mor Çimento",
  "block.minecraft.purple_glazed_terracotta": "Sırlanmış Mor Terakota",
  "block.minecraft.purple_shulker_box": "Mor Shulker Kutusu",
  "block.minecraft.purple_stained_glass": "Mor Boyalı Cam",
  "block.minecraft.purple_stained_glass_pane": "Mor Boyalı İnce Cam",
  "block.minecraft.purple_terracotta": "Mor Terakota",
  "block.minecraft.purple_wool": "Mor Yün",
  "block.minecraft.purpur_block": "Purpur Bloğu",
  "block.minecraft.purpur_pillar": "Purpur Sütun",
  "block.minecraft.purpur_slab": "Purpur Basamak",
  "block.minecraft.purpur_stairs": "Purpur Merdiven",
  "block.minecraft.quartz_block": "Kuvars Bloğu",
  "block.minecraft.quartz_bricks": "Kuvars Tuğlası",
  "block.minecraft.quartz_pillar": "Kuvars Sütun",
  "block.minecraft.quartz_slab": "Kuvars Basamak",
  "block.minecraft.quartz_stairs": "Kuvars Merdiven",
  "block.minecraft.rail": "Ray",
  "block.minecraft.raw_copper_block": "Ham Bakır Bloğu",
  "block.minecraft.raw_gold_block": "Ham Altın Bloğu",
  "block.minecraft.raw_iron_block": "Ham Demir Bloğu",
  "block.minecraft.red_banner": "Kırmızı Sancak",
  "block.minecraft.red_bed": "Kırmızı Yatak",
  "block.minecraft.red_candle": "Kırmızı Mum",
  "block.minecraft.red_candle_cake": "Kırmızı Mumlu Pasta",
  "block.minecraft.red_carpet": "Kırmızı Halı",
  "block.minecraft.red_concrete": "Kırmızı Beton",
  "block.minecraft.red_concrete_powder": "Kırmızı Çimento",
  "block.minecraft.red_glazed_terracotta": "Sırlanmış Kırmızı Terakota",
  "block.minecraft.red_mushroom": "Kırmızı Mantar",
  "block.minecraft.red_mushroom_block": "Kırmızı Mantar Bloğu",
  "block.minecraft.red_nether_brick_slab": "Kırmızı Nether Tuğlası Basamak",
  "block.minecraft.red_nether_brick_stairs": "Kırmızı Nether Tuğlası Merdiven",
  "block.minecraft.red_nether_brick_wall": "Kırmızı Nether Tuğlası Duvar",
  "block.minecraft.red_nether_bricks": "Kırmızı Nether Tuğlası",
  "block.minecraft.red_sand": "Kırmızı Kum",
  "block.minecraft.red_sandstone": "Kırmızı Kum Taşı",
  "block.minecraft.red_sandstone_slab": "Kırmızı Kum Taşı Basamak",
  "block.minecraft.red_sandstone_stairs": "Kırmızı Kum Taşı Merdiven",
  "block.minecraft.red_sandstone_wall": "Kırmızı Kum Taşı Duvar",
  "block.minecraft.red_shulker_box": "Kırmızı Shulker Kutusu",
  "block.minecraft.red_stained_glass": "Kırmızı Boyalı Cam",
  "block.minecraft.red_stained_glass_pane": "Kırmızı Boyalı İnce Cam",
  "block.minecraft.red_terracotta": "Kırmızı Terakota",
  "block.minecraft.red_tulip": "Kırmızı Lale",
  "block.minecraft.red_wool": "Kırmızı Yün",
  "block.minecraft.redstone_block": "Redstone Bloğu",
  "block.minecraft.redstone_lamp": "Redstone Lambası",
  "block.minecraft.redstone_ore": "Redstone Cevheri",
  "block.minecraft.redstone_torch": "Redstone Meşalesi",
  "block.minecraft.redstone_wall_torch": "Duvarda Redstone Meşalesi",
  "block.minecraft.redstone_wire": "Redstone Kablosu",
  "block.minecraft.reinforced_deepslate": "Güçlendirilmiş Kayrak Taşı",
  "block.minecraft.repeater": "Redstone Yineleyici",
  "block.minecraft.repeating_command_block": "Yineleyici Komut Bloğu",
  "block.minecraft.resin_block": "Reçine Bloğu",
  "block.minecraft.resin_brick_slab": "Reçine Tuğla Basamak",
  "block.minecraft.resin_brick_stairs": "Reçine Tuğla Merdiven",
  "block.minecraft.resin_brick_wall": "Reçine Tuğla Duvarı",
  "block.minecraft.resin_bricks": "Reçine Tuğla",
  "block.minecraft.resin_clump": "Reçine Yığını",
  "block.minecraft.respawn_anchor": "Diriltici",
  "block.minecraft.rooted_dirt": "Köklenmiş Toprak",
  "block.minecraft.rose_bush": "Gül Çalısı",
  "block.minecraft.sand": "Kum",
  "block.minecraft.sandstone": "Kum Taşı",
  "block.minecraft.sandstone_slab": "Kum Taşı Basamak",
  "block.minecraft.sandstone_stairs": "Kum Taşı Merdiven",
  "block.minecraft.sandstone_wall": "Kum Taşı Duvar",
  "block.minecraft.scaffolding": "İskele",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk Katalizörü",
  "block.minecraft.sculk_sensor": "Sculk Sensörü",
  "block.minecraft.sculk_shrieker": "Sculk Çığırtkanı",
  "block.minecraft.sculk_vein": "Sculk Damarı",
  "block.minecraft.sea_lantern": "Deniz Feneri",
  "block.minecraft.sea_pickle": "Pirozom",
  "block.minecraft.seagrass": "Deniz Otu",
  "block.minecraft.set_spawn": "Yeniden canlanma noktası ayarlandı",
  "block.minecraft.short_dry_grass": "Kısa Kuru Çimen",
  "block.minecraft.short_grass": "Kısa Çimen",
  "block.minecraft.shroomlight": "Mantarışığı",
  "block.minecraft.shulker_box": "Shulker Kutusu",
  "block.minecraft.skeleton_skull": "İskelet Kafası",
  "block.minecraft.skeleton_wall_skull": "Duvarda İskelet Kafatası",
  "block.minecraft.slime_block": "Balçık Bloğu",
  "block.minecraft.small_amethyst_bud": "Küçük Ametist Tomurcuğu",
  "block.minecraft.small_dripleaf": "Küçük Damla Yaprağı",
  "block.minecraft.smithing_table": "Demirci Masası",
  "block.minecraft.smoker": "Duman Fırını",
  "block.minecraft.smooth_basalt": "Düz Bazalt",
  "block.minecraft.smooth_quartz": "Düz Kuvars Bloğu",
  "block.minecraft.smooth_quartz_slab": "Düz Kuvars Basamak",
  "block.minecraft.smooth_quartz_stairs": "Düz Kuvars Merdiven",
  "block.minecraft.smooth_red_sandstone": "Düz Kırmızı Kum Taşı",
  "block.minecraft.smooth_red_sandstone_slab": "Düz Kırmızı Kum Taşı Basamak",
  "block.minecraft.smooth_red_sandstone_stairs": "Düz Kırmızı Kum Taşı Merdiven",
  "block.minecraft.smooth_sandstone": "Düz Kum Taşı",
  "block.minecraft.smooth_sandstone_slab": "Düz Kum Taşı Basamak",
  "block.minecraft.smooth_sandstone_stairs": "Düz Kum Taşı Merdiven",
  "block.minecraft.smooth_stone": "Düz Taş",
  "block.minecraft.smooth_stone_slab": "Düz Taş Basamak",
  "block.minecraft.sniffer_egg": "Koklarca Yumurtası",
  "block.minecraft.snow": "Kar",
  "block.minecraft.snow_block": "Kar Bloğu",
  "block.minecraft.soul_campfire": "Ruh Kamp Ateşi",
  "block.minecraft.soul_fire": "Ruh Ateşi",
  "block.minecraft.soul_lantern": "Ruh Feneri",
  "block.minecraft.soul_sand": "Ruh Kumu",
  "block.minecraft.soul_soil": "Ruh Toprağı",
  "block.minecraft.soul_torch": "Ruh Meşalesi",
  "block.minecraft.soul_wall_torch": "Duvarda Ruh Meşalesi",
  "block.minecraft.spawn.not_valid": "Yatağınız veya yüklenmiş bir dirilticiniz yok veya sıkışmış",
  "block.minecraft.spawner": "Canavar Çağırıcı",
  "block.minecraft.spawner.desc1": "Çağırma Yumurtası ile Etkileşime Gir:",
  "block.minecraft.spawner.desc2": "Canlı Türünü Ayarlar",
  "block.minecraft.sponge": "Sünger",
  "block.minecraft.spore_blossom": "Spor Çiçeği",
  "block.minecraft.spruce_button": "Ladin Düğme",
  "block.minecraft.spruce_door": "Ladin Kapı",
  "block.minecraft.spruce_fence": "Ladin Çit",
  "block.minecraft.spruce_fence_gate": "Ladin Çit Kapısı",
  "block.minecraft.spruce_hanging_sign": "Asılı Ladin Tabela",
  "block.minecraft.spruce_leaves": "Ladin Yaprakları",
  "block.minecraft.spruce_log": "Ladin Kütüğü",
  "block.minecraft.spruce_planks": "Ladin Tahtası",
  "block.minecraft.spruce_pressure_plate": "Ladin Basınç Plakası",
  "block.minecraft.spruce_sapling": "Ladin Ağacı Fidanı",
  "block.minecraft.spruce_shelf": "Ladin Raf",
  "block.minecraft.spruce_sign": "Ladin Tabela",
  "block.minecraft.spruce_slab": "Ladin Basamak",
  "block.minecraft.spruce_stairs": "Ladin Merdiven",
  "block.minecraft.spruce_trapdoor": "Ladin Tuzak Kapısı",
  "block.minecraft.spruce_wall_hanging_sign": "Asılı Ladin Duvar Tabelası",
  "block.minecraft.spruce_wall_sign": "Ladin Duvar Tabelası",
  "block.minecraft.spruce_wood": "Ladin Odunu",
  "block.minecraft.sticky_piston": "Yapışkan Piston",
  "block.minecraft.stone": "Taş",
  "block.minecraft.stone_brick_slab": "Taş Tuğlası Basamak",
  "block.minecraft.stone_brick_stairs": "Taş Tuğlası Merdiven",
  "block.minecraft.stone_brick_wall": "Taş Tuğlası Duvar",
  "block.minecraft.stone_bricks": "Taş Tuğlası",
  "block.minecraft.stone_button": "Taş Düğme",
  "block.minecraft.stone_pressure_plate": "Taş Basınç Plakası",
  "block.minecraft.stone_slab": "Taş Basamak",
  "block.minecraft.stone_stairs": "Taş Merdiven",
  "block.minecraft.stonecutter": "Taş Yontma Makinesi",
  "block.minecraft.stripped_acacia_log": "Soyulmuş Akasya Kütüğü",
  "block.minecraft.stripped_acacia_wood": "Soyulmuş Akasya Odunu",
  "block.minecraft.stripped_bamboo_block": "Soyulmuş Bambu Bloğu",
  "block.minecraft.stripped_birch_log": "Soyulmuş Huş Kütüğü",
  "block.minecraft.stripped_birch_wood": "Soyulmuş Huş Odunu",
  "block.minecraft.stripped_cherry_log": "Soyulmuş Kiraz Ağacı Kütüğü",
  "block.minecraft.stripped_cherry_wood": "Soyulmuş Kiraz Ağacı Odunu",
  "block.minecraft.stripped_crimson_hyphae": "Soyulmuş Kızıl Hif",
  "block.minecraft.stripped_crimson_stem": "Soyulmuş Kızıl Kök",
  "block.minecraft.stripped_dark_oak_log": "Soyulmuş Koyu Meşe Kütüğü",
  "block.minecraft.stripped_dark_oak_wood": "Soyulmuş Koyu Meşe Odunu",
  "block.minecraft.stripped_jungle_log": "Soyulmuş Orman Ağacı Kütüğü",
  "block.minecraft.stripped_jungle_wood": "Soyulmuş Orman Ağacı Odunu",
  "block.minecraft.stripped_mangrove_log": "Soyulmuş Mangrov Kütüğü",
  "block.minecraft.stripped_mangrove_wood": "Soyulmuş Mangrov Odunu",
  "block.minecraft.stripped_oak_log": "Soyulmuş Meşe Kütüğü",
  "block.minecraft.stripped_oak_wood": "Soyulmuş Meşe Odunu",
  "block.minecraft.stripped_pale_oak_log": "Soyulmuş Soluk Meşe Kütüğü",
  "block.minecraft.stripped_pale_oak_wood": "Soyulmuş Soluk Meşe Odunu",
  "block.minecraft.stripped_spruce_log": "Soyulmuş Ladin Kütüğü",
  "block.minecraft.stripped_spruce_wood": "Soyulmuş Ladin Odunu",
  "block.minecraft.stripped_warped_hyphae": "Soyulmuş Çarpık Hif",
  "block.minecraft.stripped_warped_stem": "Soyulmuş Çarpık Kök",
  "block.minecraft.structure_block": "Yapı Bloğu",
  "block.minecraft.structure_void": "Yapı Boşluğu",
  "block.minecraft.sugar_cane": "Şeker Kamışı",
  "block.minecraft.sunflower": "Ayçiçeği",
  "block.minecraft.suspicious_gravel": "Şüpheli Çakıl",
  "block.minecraft.suspicious_sand": "Şüpheli Kum",
  "block.minecraft.sweet_berry_bush": "Tatlı Orman Meyvesi Çalısı",
  "block.minecraft.tall_dry_grass": "Uzun Kuru Çimen",
  "block.minecraft.tall_grass": "Uzun Çimen",
  "block.minecraft.tall_seagrass": "Uzun Deniz Otu",
  "block.minecraft.target": "Hedef",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Test Bloğu",
  "block.minecraft.test_instance_block": "Test Birim Bloğu",
  "block.minecraft.tinted_glass": "Gölgeli Cam",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT patlamaları devre dışı",
  "block.minecraft.torch": "Meşale",
  "block.minecraft.torchflower": "Meşale Çiçeği",
  "block.minecraft.torchflower_crop": "Meşale Çiçeği Ekini",
  "block.minecraft.trapped_chest": "Tuzaklı Sandık",
  "block.minecraft.trial_spawner": "Sınama Çağırıcısı",
  "block.minecraft.tripwire": "Tuzak İpi",
  "block.minecraft.tripwire_hook": "Tuzak Kancası",
  "block.minecraft.tube_coral": "Tüp Mercanı",
  "block.minecraft.tube_coral_block": "Tüp Mercanı Bloğu",
  "block.minecraft.tube_coral_fan": "Tüp Yelpaze Mercanı",
  "block.minecraft.tube_coral_wall_fan": "Duvarda Tüp Yelpaze Mercanı",
  "block.minecraft.tuff": "Tüf",
  "block.minecraft.tuff_brick_slab": "Tüf Tuğla Basamak",
  "block.minecraft.tuff_brick_stairs": "Tüf Tuğla Merdiven",
  "block.minecraft.tuff_brick_wall": "Tüf Tuğla Duvarı",
  "block.minecraft.tuff_bricks": "Tüf Tuğla",
  "block.minecraft.tuff_slab": "Tüf Basamak",
  "block.minecraft.tuff_stairs": "Tüf Merdiven",
  "block.minecraft.tuff_wall": "Tüf Duvar",
  "block.minecraft.turtle_egg": "Kaplumbağa Yumurtası",
  "block.minecraft.twisting_vines": "Bükük Sarmaşık",
  "block.minecraft.twisting_vines_plant": "Bükük Sarmaşık Bitkisi",
  "block.minecraft.vault": "Kasa",
  "block.minecraft.verdant_froglight": "Yeşil Kurbağa Işığı",
  "block.minecraft.vine": "Sarmaşık",
  "block.minecraft.void_air": "Boşluk Havası",
  "block.minecraft.wall_torch": "Duvar Meşalesi",
  "block.minecraft.warped_button": "Çarpık Düğme",
  "block.minecraft.warped_door": "Çarpık Kapı",
  "block.minecraft.warped_fence": "Çarpık Çit",
  "block.minecraft.warped_fence_gate": "Çarpık Çit Kapısı",
  "block.minecraft.warped_fungus": "Çarpık Mantar",
  "block.minecraft.warped_hanging_sign": "Asılı Çarpık Tabela",
  "block.minecraft.warped_hyphae": "Çarpık Hif",
  "block.minecraft.warped_nylium": "Çarpık Niselyum",
  "block.minecraft.warped_planks": "Çarpık Tahta",
  "block.minecraft.warped_pressure_plate": "Çarpık Basınç Plakası",
  "block.minecraft.warped_roots": "Çarpık Kökler",
  "block.minecraft.warped_shelf": "Çarpık Raf",
  "block.minecraft.warped_sign": "Çarpık Tabela",
  "block.minecraft.warped_slab": "Çarpık Basamak",
  "block.minecraft.warped_stairs": "Çarpık Merdiven",
  "block.minecraft.warped_stem": "Çarpık Kök",
  "block.minecraft.warped_trapdoor": "Çarpık Tuzak Kapısı",
  "block.minecraft.warped_wall_hanging_sign": "Asılı Çarpık Duvar Tabelası",
  "block.minecraft.warped_wall_sign": "Çarpık Duvar Tabelası",
  "block.minecraft.warped_wart_block": "Çarpık Yumru Bloğu",
  "block.minecraft.water": "Su",
  "block.minecraft.water_cauldron": "Su Kazanı",
  "block.minecraft.waxed_chiseled_copper": "Cilalı Yontulmuş Bakır",
  "block.minecraft.waxed_copper_bars": "Cilalı Bakır Parmaklık",
  "block.minecraft.waxed_copper_block": "Cilalı Bakır Bloğu",
  "block.minecraft.waxed_copper_bulb": "Cilalı Bakır Ampul",
  "block.minecraft.waxed_copper_chain": "Cilalı Bakır Zincir",
  "block.minecraft.waxed_copper_chest": "Cilalı Bakır Sandık",
  "block.minecraft.waxed_copper_door": "Cilalı Bakır Kapı",
  "block.minecraft.waxed_copper_golem_statue": "Cilalı Bakır Golem Heykeli",
  "block.minecraft.waxed_copper_grate": "Cilalı Bakır Izgara",
  "block.minecraft.waxed_copper_lantern": "Cilalı Bakır Fener",
  "block.minecraft.waxed_copper_trapdoor": "Cilalı Bakır Tuzak Kapısı",
  "block.minecraft.waxed_cut_copper": "Cilalı Kesilmiş Bakır",
  "block.minecraft.waxed_cut_copper_slab": "Cilalı Kesilmiş Bakır Basamak",
  "block.minecraft.waxed_cut_copper_stairs": "Cilalı Kesilmiş Bakır Merdiven",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cilalı Açıkta Kalmış Yontulmuş Bakır",
  "block.minecraft.waxed_exposed_copper": "Cilalı Açıkta Kalmış Bakır",
  "block.minecraft.waxed_exposed_copper_bars": "Cilalı Açıkta Kalmış Bakır Parmaklık",
  "block.minecraft.waxed_exposed_copper_bulb": "Cilalı Açıkta Kalmış Bakır Ampul",
  "block.minecraft.waxed_exposed_copper_chain": "Cilalı Açıkta Kalmış Bakır Zincir",
  "block.minecraft.waxed_exposed_copper_chest": "Cilalı Açıkta Kalmış Bakır Sandık",
  "block.minecraft.waxed_exposed_copper_door": "Cilalı Açıkta Kalmış Bakır Kapı",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Cilalı Açıkta Kalmış Bakır Golem Heykeli",
  "block.minecraft.waxed_exposed_copper_grate": "Cilalı Açıkta Kalmış Bakır Izgara",
  "block.minecraft.waxed_exposed_copper_lantern": "Cilalı Açıkta Kalmış Bakır Fener",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Cilalı Açıkta Kalmış Bakır Tuzak Kapısı",
  "block.minecraft.waxed_exposed_cut_copper": "Cilalı Açıkta Kalmış Kesilmiş Bakır",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Cilalı Açıkta Kalmış Kesilmiş Bakır Basamak",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Cilalı Açıkta Kalmış Kesilmiş Bakır Merdiven",
  "block.minecraft.waxed_exposed_lightning_rod": "Cilalı Açıkta Kalmış Paratoner",
  "block.minecraft.waxed_lightning_rod": "Cilalı Paratoner",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cilalı Oksitlenmiş Yontulmuş Bakır",
  "block.minecraft.waxed_oxidized_copper": "Cilalı Oksitlenmiş Bakır",
  "block.minecraft.waxed_oxidized_copper_bars": "Cilalı Oksitlenmiş Bakır Parmaklık",
  "block.minecraft.waxed_oxidized_copper_bulb": "Cilalı Oksitlenmiş Bakır Ampul",
  "block.minecraft.waxed_oxidized_copper_chain": "Cilalı Oksitlenmiş Bakır Zincir",
  "block.minecraft.waxed_oxidized_copper_chest": "Cilalı Oksitlenmiş Bakır Sandık",
  "block.minecraft.waxed_oxidized_copper_door": "Cilalı Oksitlenmiş Bakır Kapı",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Cilalı Oksitlenmiş Bakır Golem Heykeli",
  "block.minecraft.waxed_oxidized_copper_grate": "Cilalı Oksitlenmiş Bakır Izgara",
  "block.minecraft.waxed_oxidized_copper_lantern": "Cilalı Oksitlenmiş Bakır Fener",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Cilalı Oksitlenmiş Bakır Tuzak Kapısı",
  "block.minecraft.waxed_oxidized_cut_copper": "Cilalı Oksitlenmiş Kesilmiş Bakır",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Cilalı Oksitlenmiş Kesilmiş Bakır Basamak",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Cilalı Oksitlenmiş Kesilmiş Bakır Merdiven",
  "block.minecraft.waxed_oxidized_lightning_rod": "Cilalı Oksitlenmiş Paratoner",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cilalı Yıpranmış Yontulmuş Bakır",
  "block.minecraft.waxed_weathered_copper": "Cilalı Yıpranmış Bakır",
  "block.minecraft.waxed_weathered_copper_bars": "Cilalı Yıpranmış Bakır Parmaklık",
  "block.minecraft.waxed_weathered_copper_bulb": "Cilalı Yıpranmış Bakır Ampul",
  "block.minecraft.waxed_weathered_copper_chain": "Cilalı Yıpranmış Bakır Zincir",
  "block.minecraft.waxed_weathered_copper_chest": "Cilalı Yıpranmış Bakır Sandık",
  "block.minecraft.waxed_weathered_copper_door": "Cilalı Yıpranmış Bakır Kapı",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Cilalı Yıpranmış Bakır Golem Heykeli",
  "block.minecraft.waxed_weathered_copper_grate": "Cilalı Yıpranmış Bakır Izgara",
  "block.minecraft.waxed_weathered_copper_lantern": "Cilalı Yıpranmış Bakır Fener",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Cilalı Yıpranmış Bakır Tuzak Kapısı",
  "block.minecraft.waxed_weathered_cut_copper": "Cilalı Yıpranmış Kesilmiş Bakır",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Cilalı Yıpranmış Kesilmiş Bakır Basamak",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Cilalı Yıpranmış Kesilmiş Bakır Merdiven",
  "block.minecraft.waxed_weathered_lightning_rod": "Cilalı Yıpranmış Paratoner",
  "block.minecraft.weathered_chiseled_copper": "Yıpranmış Yontulmuş Bakır",
  "block.minecraft.weathered_copper": "Yıpranmış Bakır",
  "block.minecraft.weathered_copper_bars": "Yıpranmış Bakır Parmaklık",
  "block.minecraft.weathered_copper_bulb": "Yıpranmış Bakır Ampul",
  "block.minecraft.weathered_copper_chain": "Yıpranmış Bakır Zincir",
  "block.minecraft.weathered_copper_chest": "Yıpranmış Bakır Sandık",
  "block.minecraft.weathered_copper_door": "Yıpranmış Bakır Kapı",
  "block.minecraft.weathered_copper_golem_statue": "Yıpranmış Bakır Golem Heykeli",
  "block.minecraft.weathered_copper_grate": "Yıpranmış Bakır Izgara",
  "block.minecraft.weathered_copper_lantern": "Yıpranmış Bakır Fener",
  "block.minecraft.weathered_copper_trapdoor": "Yıpranmış Bakır Tuzak Kapısı",
  "block.minecraft.weathered_cut_copper": "Yıpranmış Kesilmiş Bakır",
  "block.minecraft.weathered_cut_copper_slab": "Yıpranmış Kesilmiş Bakır Basamak",
  "block.minecraft.weathered_cut_copper_stairs": "Yıpranmış Kesilmiş Bakır Merdiven",
  "block.minecraft.weathered_lightning_rod": "Yıpranmış Paratoner",
  "block.minecraft.weeping_vines": "Ağlayan Sarmaşık",
  "block.minecraft.weeping_vines_plant": "Ağlayan Sarmaşık Bitkisi",
  "block.minecraft.wet_sponge": "Islak Sünger",
  "block.minecraft.wheat": "Buğday Ekini",
  "block.minecraft.white_banner": "Beyaz Sancak",
  "block.minecraft.white_bed": "Beyaz Yatak",
  "block.minecraft.white_candle": "Beyaz Mum",
  "block.minecraft.white_candle_cake": "Beyaz Mumlu Pasta",
  "block.minecraft.white_carpet": "Beyaz Halı",
  "block.minecraft.white_concrete": "Beyaz Beton",
  "block.minecraft.white_concrete_powder": "Beyaz Çimento",
  "block.minecraft.white_glazed_terracotta": "Sırlanmış Beyaz Terakota",
  "block.minecraft.white_shulker_box": "Beyaz Shulker Kutusu",
  "block.minecraft.white_stained_glass": "Beyaz Boyalı Cam",
  "block.minecraft.white_stained_glass_pane": "Beyaz Boyalı İnce Cam",
  "block.minecraft.white_terracotta": "Beyaz Terakota",
  "block.minecraft.white_tulip": "Beyaz Lale",
  "block.minecraft.white_wool": "Beyaz Yün",
  "block.minecraft.wildflowers": "Kır Çiçekleri",
  "block.minecraft.wither_rose": "Wither Gülü",
  "block.minecraft.wither_skeleton_skull": "Wither İskeleti Kafatası",
  "block.minecraft.wither_skeleton_wall_skull": "Duvarda Wither İskeleti Kafatası",
  "block.minecraft.yellow_banner": "Sarı Sancak",
  "block.minecraft.yellow_bed": "Sarı Yatak",
  "block.minecraft.yellow_candle": "Sarı Mum",
  "block.minecraft.yellow_candle_cake": "Sarı Mumlu Pasta",
  "block.minecraft.yellow_carpet": "Sarı Halı",
  "block.minecraft.yellow_concrete": "Sarı Beton",
  "block.minecraft.yellow_concrete_powder": "Sarı Çimento",
  "block.minecraft.yellow_glazed_terracotta": "Sırlanmış Sarı Terakota",
  "block.minecraft.yellow_shulker_box": "Sarı Shulker Kutusu",
  "block.minecraft.yellow_stained_glass": "Sarı Boyalı Cam",
  "block.minecraft.yellow_stained_glass_pane": "Sarı Boyalı İnce Cam",
  "block.minecraft.yellow_terracotta": "Sarı Terakota",
  "block.minecraft.yellow_wool": "Sarı Yün",
  "block.minecraft.zombie_head": "Zombi Kafası",
  "block.minecraft.zombie_wall_head": "Duvarda Zombi Kafası",
  "item.minecraft.acacia_boat": "Akasya Tekne",
  "item.minecraft.acacia_chest_boat": "Sandıklı Akasya Tekne",
  "item.minecraft.allay_spawn_egg": "Huzurveren Çağırma Yumurtası",
  "item.minecraft.amethyst_shard": "Ametist Parçası",
  "item.minecraft.angler_pottery_shard": "Fener Çömlek Parçası",
  "item.minecraft.angler_pottery_sherd": "Balıkçı Çömlek Parçası",
  "item.minecraft.apple": "Elma",
  "item.minecraft.archer_pottery_shard": "Okçu Çömlek Parçası",
  "item.minecraft.archer_pottery_sherd": "Okçu Çömlek Parçası",
  "item.minecraft.armadillo_scute": "Armadillo Pulu",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Çağırma Yumurtası",
  "item.minecraft.armor_stand": "Zırh Askısı",
  "item.minecraft.arms_up_pottery_shard": "Kollar Yukarı Çömlek Parçası",
  "item.minecraft.arms_up_pottery_sherd": "Eller Yukarı Çömlek Parçası",
  "item.minecraft.arrow": "Ok",
  "item.minecraft.axolotl_bucket": "Aksolotl Kovası",
  "item.minecraft.axolotl_spawn_egg": "Aksolotl Çağırma Yumurtası",
  "item.minecraft.baked_potato": "Pişmiş Patates",
  "item.minecraft.bamboo_chest_raft": "Sandıklı Bambu Sal",
  "item.minecraft.bamboo_raft": "Bambu Sal",
  "item.minecraft.bat_spawn_egg": "Yarasa Çağırma Yumurtası",
  "item.minecraft.bee_spawn_egg": "Arı Çağırma Yumurtası",
  "item.minecraft.beef": "Çiğ İnek Eti",
  "item.minecraft.beetroot": "Pancar",
  "item.minecraft.beetroot_seeds": "Pancar Tohumu",
  "item.minecraft.beetroot_soup": "Pancar Çorbası",
  "item.minecraft.birch_boat": "Huş Tekne",
  "item.minecraft.birch_chest_boat": "Sandıklı Huş Tekne",
  "item.minecraft.black_bundle": "Siyah Kese",
  "item.minecraft.black_dye": "Siyah Boya",
  "item.minecraft.black_harness": "Siyah Dizgin",
  "item.minecraft.blade_pottery_shard": "Bıçak Çömlek Parçası",
  "item.minecraft.blade_pottery_sherd": "Bıçak Çömlek Parçası",
  "item.minecraft.blaze_powder": "Blaze Tozu",
  "item.minecraft.blaze_rod": "Blaze Çubuğu",
  "item.minecraft.blaze_spawn_egg": "Blaze Çağırma Yumurtası",
  "item.minecraft.blue_bundle": "Mavi Kese",
  "item.minecraft.blue_dye": "Mavi Boya",
  "item.minecraft.blue_egg": "Mavi Yumurta",
  "item.minecraft.blue_harness": "Mavi Dizgin",
  "item.minecraft.bogged_spawn_egg": "Batık Çağırma Yumurtası",
  "item.minecraft.bolt_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Şimşek Zırh Süslemesi",
  "item.minecraft.bone": "Kemik",
  "item.minecraft.bone_meal": "Kemik Tozu",
  "item.minecraft.book": "Kitap",
  "item.minecraft.bordure_indented_banner_pattern": "Testere Dişi Çerçeve Sancak Deseni",
  "item.minecraft.bow": "Yay",
  "item.minecraft.bowl": "Kâse",
  "item.minecraft.bread": "Ekmek",
  "item.minecraft.breeze_rod": "Esinti Çubuğu",
  "item.minecraft.breeze_spawn_egg": "Esinti Çağırma Yumurtası",
  "item.minecraft.brewer_pottery_shard": "İksirci Çömlek Parçası",
  "item.minecraft.brewer_pottery_sherd": "İksirci Çömlek Parçası",
  "item.minecraft.brewing_stand": "İksir Tezgâhı",
  "item.minecraft.brick": "Tuğla",
  "item.minecraft.brown_bundle": "Kahverengi Kese",
  "item.minecraft.brown_dye": "Kahverengi Boya",
  "item.minecraft.brown_egg": "Kahverengi Yumurta",
  "item.minecraft.brown_harness": "Kahverengi Dizgin",
  "item.minecraft.brush": "Fırça",
  "item.minecraft.bucket": "Kova",
  "item.minecraft.bundle": "Kese",
  "item.minecraft.bundle.empty": "Boş",
  "item.minecraft.bundle.empty.description": "Çeşitli eşyalardan bir yığın taşıyabilir",
  "item.minecraft.bundle.full": "Dolu",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Yanma Çömlek Parçası",
  "item.minecraft.burn_pottery_sherd": "Yanma Çömlek Parçası",
  "item.minecraft.camel_husk_spawn_egg": "Kalıntı Deve Çağırma Yumurtası",
  "item.minecraft.camel_spawn_egg": "Deve Çağırma Yumurtası",
  "item.minecraft.carrot": "Havuç",
  "item.minecraft.carrot_on_a_stick": "Havuçlu Olta",
  "item.minecraft.cat_spawn_egg": "Kedi Çağırma Yumurtası",
  "item.minecraft.cauldron": "Kazan",
  "item.minecraft.cave_spider_spawn_egg": "Mağara Örümceği Çağırma Yumurtası",
  "item.minecraft.chainmail_boots": "Zincir Çizme",
  "item.minecraft.chainmail_chestplate": "Zincir Göğüslük",
  "item.minecraft.chainmail_helmet": "Zincir Miğfer",
  "item.minecraft.chainmail_leggings": "Zincir Tozluk",
  "item.minecraft.charcoal": "Odun Kömürü",
  "item.minecraft.cherry_boat": "Kiraz Ağacı Tekne",
  "item.minecraft.cherry_chest_boat": "Sandıklı Kiraz Ağacı Tekne",
  "item.minecraft.chest_minecart": "Sandıklı Vagon",
  "item.minecraft.chicken": "Çiğ Tavuk Eti",
  "item.minecraft.chicken_spawn_egg": "Tavuk Çağırma Yumurtası",
  "item.minecraft.chorus_fruit": "Nakarat Meyvesi",
  "item.minecraft.clay_ball": "Kil Topu",
  "item.minecraft.clock": "Saat",
  "item.minecraft.coal": "Kömür",
  "item.minecraft.coast_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Kıyı Zırh Süslemesi",
  "item.minecraft.cocoa_beans": "Kakao Çekirdekleri",
  "item.minecraft.cod": "Çiğ Morina",
  "item.minecraft.cod_bucket": "Morina Kovası",
  "item.minecraft.cod_spawn_egg": "Morina Çağırma Yumurtası",
  "item.minecraft.command_block_minecart": "Komut Bloklu Vagon",
  "item.minecraft.compass": "Pusula",
  "item.minecraft.cooked_beef": "Biftek",
  "item.minecraft.cooked_chicken": "Pişmiş Tavuk Eti",
  "item.minecraft.cooked_cod": "Pişmiş Morina",
  "item.minecraft.cooked_mutton": "Pişmiş Koyun Eti",
  "item.minecraft.cooked_porkchop": "Pişmiş Domuz Pirzolası",
  "item.minecraft.cooked_rabbit": "Pişmiş Tavşan Eti",
  "item.minecraft.cooked_salmon": "Pişmiş Somon",
  "item.minecraft.cookie": "Kurabiye",
  "item.minecraft.copper_axe": "Bakır Balta",
  "item.minecraft.copper_boots": "Bakır Çizme",
  "item.minecraft.copper_chestplate": "Bakır Göğüslük",
  "item.minecraft.copper_golem_spawn_egg": "Bakır Golem Çağırma Yumurtası",
  "item.minecraft.copper_helmet": "Bakır Miğfer",
  "item.minecraft.copper_hoe": "Bakır Çapa",
  "item.minecraft.copper_horse_armor": "Bakır At Zırhı",
  "item.minecraft.copper_ingot": "Bakır Külçesi",
  "item.minecraft.copper_leggings": "Bakır Tozluk",
  "item.minecraft.copper_nautilus_armor": "Bakır Notilus Zırhı",
  "item.minecraft.copper_nugget": "Bakır Parçası",
  "item.minecraft.copper_pickaxe": "Bakır Kazma",
  "item.minecraft.copper_shovel": "Bakır Kürek",
  "item.minecraft.copper_spear": "Bakır Mızrak",
  "item.minecraft.copper_sword": "Bakır Kılıç",
  "item.minecraft.cow_spawn_egg": "İnek Çağırma Yumurtası",
  "item.minecraft.creaking_spawn_egg": "Gıcırtı Çağırma Yumurtası",
  "item.minecraft.creeper_banner_pattern": "Sancak Deseni",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper Şekli",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Şekli Sancak Deseni",
  "item.minecraft.creeper_spawn_egg": "Creeper Çağırma Yumurtası",
  "item.minecraft.crossbow": "Arbalet",
  "item.minecraft.crossbow.projectile": "Cephane:",
  "item.minecraft.crossbow.projectile.multiple": "Cephane: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Cephane: %s",
  "item.minecraft.cyan_bundle": "Camgöbeği Kese",
  "item.minecraft.cyan_dye": "Camgöbeği Boya",
  "item.minecraft.cyan_harness": "Camgöbeği Dizgin",
  "item.minecraft.danger_pottery_shard": "Tehlike Çömlek Parçası",
  "item.minecraft.danger_pottery_sherd": "Tehlike Çömlek Parçası",
  "item.minecraft.dark_oak_boat": "Koyu Meşe Tekne",
  "item.minecraft.dark_oak_chest_boat": "Sandıklı Koyu Meşe Tekne",
  "item.minecraft.debug_stick": "Hata Ayıklama Çubuğu",
  "item.minecraft.debug_stick.empty": "%s hiçbir özelliğe sahip değil",
  "item.minecraft.debug_stick.select": "\"%s” (%s) seçildi",
  "item.minecraft.debug_stick.update": "\"%s” -> %s",
  "item.minecraft.diamond": "Elmas",
  "item.minecraft.diamond_axe": "Elmas Balta",
  "item.minecraft.diamond_boots": "Elmas Çizme",
  "item.minecraft.diamond_chestplate": "Elmas Göğüslük",
  "item.minecraft.diamond_helmet": "Elmas Miğfer",
  "item.minecraft.diamond_hoe": "Elmas Çapa",
  "item.minecraft.diamond_horse_armor": "Elmas At Zırhı",
  "item.minecraft.diamond_leggings": "Elmas Tozluk",
  "item.minecraft.diamond_nautilus_armor": "Elmas Notilus Zırhı",
  "item.minecraft.diamond_pickaxe": "Elmas Kazma",
  "item.minecraft.diamond_shovel": "Elmas Kürek",
  "item.minecraft.diamond_spear": "Elmas Mızrak",
  "item.minecraft.diamond_sword": "Elmas Kılıç",
  "item.minecraft.disc_fragment_5": "Disk Parçası",
  "item.minecraft.disc_fragment_5.desc": "Müzik Diski - 5",
  "item.minecraft.dolphin_spawn_egg": "Yunus Çağırma Yumurtası",
  "item.minecraft.donkey_spawn_egg": "Eşek Çağırma Yumurtası",
  "item.minecraft.dragon_breath": "Ejderha Nefesi",
  "item.minecraft.dried_kelp": "Kurutulmuş Su Yosunu",
  "item.minecraft.drowned_spawn_egg": "Boğuk Çağırma Yumurtası",
  "item.minecraft.dune_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Kumul Zırh Süslemesi",
  "item.minecraft.echo_shard": "Yankı Parçacığı",
  "item.minecraft.egg": "Yumurta",
  "item.minecraft.elder_guardian_spawn_egg": "Yaşlı Gardiyan Çağırma Yumurtası",
  "item.minecraft.elytra": "Elitra",
  "item.minecraft.emerald": "Zümrüt",
  "item.minecraft.enchanted_book": "Büyülü Kitap",
  "item.minecraft.enchanted_golden_apple": "Büyülü Altın Elma",
  "item.minecraft.end_crystal": "End Kristali",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Ejderhası Çağırma Yumurtası",
  "item.minecraft.ender_eye": "Ender Gözü",
  "item.minecraft.ender_pearl": "Ender İncisi",
  "item.minecraft.enderman_spawn_egg": "Enderman Çağırma Yumurtası",
  "item.minecraft.endermite_spawn_egg": "Endermite Çağırma Yumurtası",
  "item.minecraft.evoker_spawn_egg": "Uyandırıcı Çağırma Yumurtası",
  "item.minecraft.experience_bottle": "Tecrübe İksiri",
  "item.minecraft.explorer_pottery_shard": "Kâşif Çömlek Parçası",
  "item.minecraft.explorer_pottery_sherd": "Kâşif Çömlek Parçası",
  "item.minecraft.eye_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Göz Zırh Süslemesi",
  "item.minecraft.feather": "Tüy",
  "item.minecraft.fermented_spider_eye": "Mayalı Örümcek Gözü",
  "item.minecraft.field_masoned_banner_pattern": "Tuğla Sancak Deseni",
  "item.minecraft.filled_map": "Harita",
  "item.minecraft.fire_charge": "Ateş Topu",
  "item.minecraft.firework_rocket": "Havai Fişek Roketi",
  "item.minecraft.firework_rocket.flight": "Uçuş Süresi:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Havai Fişek Yıldızı",
  "item.minecraft.firework_star.black": "Siyah",
  "item.minecraft.firework_star.blue": "Mavi",
  "item.minecraft.firework_star.brown": "Kahverengi",
  "item.minecraft.firework_star.custom_color": "Özel",
  "item.minecraft.firework_star.cyan": "Camgöbeği",
  "item.minecraft.firework_star.fade_to": "Geçiş Rengi",
  "item.minecraft.firework_star.flicker": "Parıltı",
  "item.minecraft.firework_star.gray": "Gri",
  "item.minecraft.firework_star.green": "Yeşil",
  "item.minecraft.firework_star.light_blue": "Açık Mavi",
  "item.minecraft.firework_star.light_gray": "Açık Gri",
  "item.minecraft.firework_star.lime": "Açık Yeşil",
  "item.minecraft.firework_star.magenta": "Eflatun",
  "item.minecraft.firework_star.orange": "Turuncu",
  "item.minecraft.firework_star.pink": "Pembe",
  "item.minecraft.firework_star.purple": "Mor",
  "item.minecraft.firework_star.red": "Kırmızı",
  "item.minecraft.firework_star.shape": "Bilinmeyen Şekil",
  "item.minecraft.firework_star.shape.burst": "Patlama",
  "item.minecraft.firework_star.shape.creeper": "Creeper Şekilli",
  "item.minecraft.firework_star.shape.large_ball": "Büyük Top",
  "item.minecraft.firework_star.shape.small_ball": "Küçük Top",
  "item.minecraft.firework_star.shape.star": "Yıldız Şekilli",
  "item.minecraft.firework_star.trail": "İz",
  "item.minecraft.firework_star.white": "Beyaz",
  "item.minecraft.firework_star.yellow": "Sarı",
  "item.minecraft.fishing_rod": "Olta",
  "item.minecraft.flint": "Çakmak Taşı",
  "item.minecraft.flint_and_steel": "Çakmak Taşı ve Çelik",
  "item.minecraft.flow_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Akış Zırh Süslemesi",
  "item.minecraft.flow_banner_pattern": "Sancak Deseni",
  "item.minecraft.flow_banner_pattern.desc": "Akış",
  "item.minecraft.flow_banner_pattern.new": "Akış Sancak Deseni",
  "item.minecraft.flow_pottery_sherd": "Akış Çömlek Parçası",
  "item.minecraft.flower_banner_pattern": "Sancak Deseni",
  "item.minecraft.flower_banner_pattern.desc": "Çiçek Şekli",
  "item.minecraft.flower_banner_pattern.new": "Çiçek Şekli Sancak Deseni",
  "item.minecraft.flower_pot": "Saksı",
  "item.minecraft.fox_spawn_egg": "Tilki Çağırma Yumurtası",
  "item.minecraft.friend_pottery_shard": "Arkadaş Çömlek Parçası",
  "item.minecraft.friend_pottery_sherd": "Arkadaş Çömlek Parçası",
  "item.minecraft.frog_spawn_egg": "Kurbağa Çağırma Yumurtası",
  "item.minecraft.furnace_minecart": "Ocaklı Vagon",
  "item.minecraft.ghast_spawn_egg": "Ghast Çağırma Yumurtası",
  "item.minecraft.ghast_tear": "Ghast Gözyaşı",
  "item.minecraft.glass_bottle": "Cam Şişe",
  "item.minecraft.glistering_melon_slice": "Parlayan Karpuz Dilimi",
  "item.minecraft.globe_banner_pattern": "Sancak Deseni",
  "item.minecraft.globe_banner_pattern.desc": "Dünya",
  "item.minecraft.globe_banner_pattern.new": "Dünya Sancak Deseni",
  "item.minecraft.glow_berries": "Parlayan Meyveler",
  "item.minecraft.glow_ink_sac": "Parlayan Mürekkep Kesesi",
  "item.minecraft.glow_item_frame": "Parlayan Eşya Çerçevesi",
  "item.minecraft.glow_squid_spawn_egg": "Parlayan Mürekkep Balığı Çağırma Yumurtası",
  "item.minecraft.glowstone_dust": "Işık Taşı Tozu",
  "item.minecraft.goat_horn": "Keçi Boynuzu",
  "item.minecraft.goat_spawn_egg": "Keçi Çağırma Yumurtası",
  "item.minecraft.gold_ingot": "Altın Külçesi",
  "item.minecraft.gold_nugget": "Altın Parçası",
  "item.minecraft.golden_apple": "Altın Elma",
  "item.minecraft.golden_axe": "Altın Balta",
  "item.minecraft.golden_boots": "Altın Çizme",
  "item.minecraft.golden_carrot": "Altın Havuç",
  "item.minecraft.golden_chestplate": "Altın Göğüslük",
  "item.minecraft.golden_helmet": "Altın Miğfer",
  "item.minecraft.golden_hoe": "Altın Çapa",
  "item.minecraft.golden_horse_armor": "Altın At Zırhı",
  "item.minecraft.golden_leggings": "Altın Tozluk",
  "item.minecraft.golden_nautilus_armor": "Altın Notilus Zırhı",
  "item.minecraft.golden_pickaxe": "Altın Kazma",
  "item.minecraft.golden_shovel": "Altın Kürek",
  "item.minecraft.golden_spear": "Altın Mızrak",
  "item.minecraft.golden_sword": "Altın Kılıç",
  "item.minecraft.gray_bundle": "Gri Kese",
  "item.minecraft.gray_dye": "Gri Boya",
  "item.minecraft.gray_harness": "Gri Dizgin",
  "item.minecraft.green_bundle": "Yeşil Kese",
  "item.minecraft.green_dye": "Yeşil Boya",
  "item.minecraft.green_harness": "Yeşil Dizgin",
  "item.minecraft.guardian_spawn_egg": "Gardiyan Çağırma Yumurtası",
  "item.minecraft.gunpowder": "Barut",
  "item.minecraft.guster_banner_pattern": "Sancak Deseni",
  "item.minecraft.guster_banner_pattern.desc": "Fırtına",
  "item.minecraft.guster_banner_pattern.new": "Fırtına Sancak Deseni",
  "item.minecraft.guster_pottery_sherd": "Fırtına Çömlek Parçası",
  "item.minecraft.happy_ghast_spawn_egg": "Mutlu Ghast Çağırma Yumurtası",
  "item.minecraft.harness": "Dizgin",
  "item.minecraft.heart_of_the_sea": "Denizin Kalbi",
  "item.minecraft.heart_pottery_shard": "Kalp Çömlek Parçası",
  "item.minecraft.heart_pottery_sherd": "Kalp Çömlek Parçası",
  "item.minecraft.heartbreak_pottery_shard": "Kırık Kalp Çömlek Parçası",
  "item.minecraft.heartbreak_pottery_sherd": "Kırık Kalp Çömlek Parçası",
  "item.minecraft.hoglin_spawn_egg": "Hoglin Çağırma Yumurtası",
  "item.minecraft.honey_bottle": "Bal Şişesi",
  "item.minecraft.honeycomb": "Bal Peteği",
  "item.minecraft.hopper_minecart": "Hunili Vagon",
  "item.minecraft.horse_spawn_egg": "At Çağırma Yumurtası",
  "item.minecraft.host_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ev Sahibi Zırh Süslemesi",
  "item.minecraft.howl_pottery_shard": "Uluma Çömlek Parçası",
  "item.minecraft.howl_pottery_sherd": "Uluma Çömlek Parçası",
  "item.minecraft.husk_spawn_egg": "Kalıntı Çağırma Yumurtası",
  "item.minecraft.ink_sac": "Mürekkep Kesesi",
  "item.minecraft.iron_axe": "Demir Balta",
  "item.minecraft.iron_boots": "Demir Çizme",
  "item.minecraft.iron_chestplate": "Demir Göğüslük",
  "item.minecraft.iron_golem_spawn_egg": "Demir Golem Çağırma Yumurtası",
  "item.minecraft.iron_helmet": "Demir Miğfer",
  "item.minecraft.iron_hoe": "Demir Çapa",
  "item.minecraft.iron_horse_armor": "Demir At Zırhı",
  "item.minecraft.iron_ingot": "Demir Külçesi",
  "item.minecraft.iron_leggings": "Demir Tozluk",
  "item.minecraft.iron_nautilus_armor": "Demir Notilus Zırhı",
  "item.minecraft.iron_nugget": "Demir Parçası",
  "item.minecraft.iron_pickaxe": "Demir Kazma",
  "item.minecraft.iron_shovel": "Demir Kürek",
  "item.minecraft.iron_spear": "Demir Mızrak",
  "item.minecraft.iron_sword": "Demir Kılıç",
  "item.minecraft.item_frame": "Eşya Çerçevesi",
  "item.minecraft.jungle_boat": "Orman Ağacı Tekne",
  "item.minecraft.jungle_chest_boat": "Sandıklı Orman Ağacı Tekne",
  "item.minecraft.knowledge_book": "İlim Kitabı",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Lav Kovası",
  "item.minecraft.lead": "Kayış",
  "item.minecraft.leather": "Deri",
  "item.minecraft.leather_boots": "Deri Çizme",
  "item.minecraft.leather_chestplate": "Deri Ceket",
  "item.minecraft.leather_helmet": "Deri Şapka",
  "item.minecraft.leather_horse_armor": "Deri At Zırhı",
  "item.minecraft.leather_leggings": "Deri Pantolon",
  "item.minecraft.light_blue_bundle": "Açık Mavi Kese",
  "item.minecraft.light_blue_dye": "Açık Mavi Boya",
  "item.minecraft.light_blue_harness": "Açık Mavi Dizgin",
  "item.minecraft.light_gray_bundle": "Açık Gri Kese",
  "item.minecraft.light_gray_dye": "Açık Gri Boya",
  "item.minecraft.light_gray_harness": "Açık Gri Dizgin",
  "item.minecraft.lime_bundle": "Açık Yeşil Kese",
  "item.minecraft.lime_dye": "Açık Yeşil Boya",
  "item.minecraft.lime_harness": "Açık Yeşil Dizgin",
  "item.minecraft.lingering_potion": "Kalıcı İksir",
  "item.minecraft.lingering_potion.effect.awkward": "Kalıcı Garip İksir",
  "item.minecraft.lingering_potion.effect.empty": "Kalıcı Üretilemeyen İksir",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Kalıcı Ateş Direnci İksiri",
  "item.minecraft.lingering_potion.effect.harming": "Kalıcı Hasar İksiri",
  "item.minecraft.lingering_potion.effect.healing": "Kalıcı İyileştirme İksiri",
  "item.minecraft.lingering_potion.effect.infested": "Kalıcı Enfeksiyon İksiri",
  "item.minecraft.lingering_potion.effect.invisibility": "Kalıcı Görünmezlik İksiri",
  "item.minecraft.lingering_potion.effect.leaping": "Kalıcı Sıçrama İksiri",
  "item.minecraft.lingering_potion.effect.levitation": "Kalıcı Yükselme İksiri",
  "item.minecraft.lingering_potion.effect.luck": "Kalıcı Şans İksiri",
  "item.minecraft.lingering_potion.effect.mundane": "Kalıcı Sıradan İksir",
  "item.minecraft.lingering_potion.effect.night_vision": "Kalıcı Gece Görüş İksiri",
  "item.minecraft.lingering_potion.effect.oozing": "Kalıcı Sızma İksiri",
  "item.minecraft.lingering_potion.effect.poison": "Kalıcı Zehir İksiri",
  "item.minecraft.lingering_potion.effect.regeneration": "Kalıcı Yenilenme İksiri",
  "item.minecraft.lingering_potion.effect.slow_falling": "Kalıcı Yavaş Düşüş İksiri",
  "item.minecraft.lingering_potion.effect.slowness": "Kalıcı Yavaşlık İksiri",
  "item.minecraft.lingering_potion.effect.strength": "Kalıcı Kuvvet İksiri",
  "item.minecraft.lingering_potion.effect.swiftness": "Kalıcı Çeviklik İksiri",
  "item.minecraft.lingering_potion.effect.thick": "Kalıcı Yoğun İksir",
  "item.minecraft.lingering_potion.effect.turtle_master": "Kalıcı Kaplumbağa Ustası İksiri",
  "item.minecraft.lingering_potion.effect.water": "Kalıcı Su Şişesi",
  "item.minecraft.lingering_potion.effect.water_breathing": "Kalıcı Su Altında Nefes Alma İksiri",
  "item.minecraft.lingering_potion.effect.weakness": "Kalıcı Zayıflık İksiri",
  "item.minecraft.lingering_potion.effect.weaving": "Kalıcı Örme İksiri",
  "item.minecraft.lingering_potion.effect.wind_charged": "Kalıcı Rüzgâr Dolu İksir",
  "item.minecraft.llama_spawn_egg": "Lama Çağırma Yumurtası",
  "item.minecraft.lodestone_compass": "Manyetit Pusulası",
  "item.minecraft.mace": "Gürz",
  "item.minecraft.magenta_bundle": "Eflatun Kese",
  "item.minecraft.magenta_dye": "Eflatun Boya",
  "item.minecraft.magenta_harness": "Eflatun Dizgin",
  "item.minecraft.magma_cream": "Magma Kremi",
  "item.minecraft.magma_cube_spawn_egg": "Magma Küpü Çağırma Yumurtası",
  "item.minecraft.mangrove_boat": "Mangrov Tekne",
  "item.minecraft.mangrove_chest_boat": "Sandıklı Mangrov Tekne",
  "item.minecraft.map": "Boş Harita",
  "item.minecraft.melon_seeds": "Karpuz Tohumu",
  "item.minecraft.melon_slice": "Karpuz Dilimi",
  "item.minecraft.milk_bucket": "Süt Kovası",
  "item.minecraft.minecart": "Vagon",
  "item.minecraft.miner_pottery_shard": "Madenci Çömlek Parçası",
  "item.minecraft.miner_pottery_sherd": "Madenci Çömlek Parçası",
  "item.minecraft.mojang_banner_pattern": "Sancak Deseni",
  "item.minecraft.mojang_banner_pattern.desc": "Şey",
  "item.minecraft.mojang_banner_pattern.new": "Şey Sancak Deseni",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom Çağırma Yumurtası",
  "item.minecraft.mourner_pottery_shard": "Ağıtçı Çömlek Parçası",
  "item.minecraft.mourner_pottery_sherd": "Ağıtçı Çömlek Parçası",
  "item.minecraft.mule_spawn_egg": "Katır Çağırma Yumurtası",
  "item.minecraft.mushroom_stew": "Mantar Güveci",
  "item.minecraft.music_disc_11": "Müzik Diski",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Müzik Diski",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Müzik Diski",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Müzik Diski",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Müzik Diski",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Müzik Diski",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Müzik Diski",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Müzik Diski",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Müzik Kutusu)",
  "item.minecraft.music_disc_far": "Müzik Diski",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Müzik Diski",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Müzik Diski",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Müzik Diski",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Müzik Diski",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Müzik Diski",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Müzik Diski",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Müzik Diski",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Müzik Diski",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Müzik Diski",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Müzik Diski",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Müzik Diski",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Müzik Diski",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Çiğ Koyun Eti",
  "item.minecraft.name_tag": "Ad Etiketi",
  "item.minecraft.nautilus_shell": "Notilus Kabuğu",
  "item.minecraft.nautilus_spawn_egg": "Notilus Çağırma Yumurtası",
  "item.minecraft.nether_brick": "Nether Tuğlası",
  "item.minecraft.nether_star": "Nether Yıldızı",
  "item.minecraft.nether_wart": "Nether Yumrusu",
  "item.minecraft.netherite_axe": "Netherit Balta",
  "item.minecraft.netherite_boots": "Netherit Çizme",
  "item.minecraft.netherite_chestplate": "Netherit Göğüslük",
  "item.minecraft.netherite_helmet": "Netherit Miğfer",
  "item.minecraft.netherite_hoe": "Netherit Çapa",
  "item.minecraft.netherite_horse_armor": "Netherit At Zırhı",
  "item.minecraft.netherite_ingot": "Netherit Külçesi",
  "item.minecraft.netherite_leggings": "Netherit Tozluk",
  "item.minecraft.netherite_nautilus_armor": "Netherit Notilus Zırhı",
  "item.minecraft.netherite_pickaxe": "Netherit Kazma",
  "item.minecraft.netherite_scrap": "Netherit Hurdası",
  "item.minecraft.netherite_shovel": "Netherit Kürek",
  "item.minecraft.netherite_spear": "Netherit Mızrak",
  "item.minecraft.netherite_sword": "Netherit Kılıç",
  "item.minecraft.netherite_upgrade_smithing_template": "Demirci Şablonu",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherit Yükseltmesi",
  "item.minecraft.oak_boat": "Meşe Tekne",
  "item.minecraft.oak_chest_boat": "Sandıklı Meşe Tekne",
  "item.minecraft.ocelot_spawn_egg": "Oselo Çağırma Yumurtası",
  "item.minecraft.ominous_bottle": "Uğursuz Şişe",
  "item.minecraft.ominous_trial_key": "Uğursuz Sınama Anahtarı",
  "item.minecraft.orange_bundle": "Turuncu Kese",
  "item.minecraft.orange_dye": "Turuncu Boya",
  "item.minecraft.orange_harness": "Turuncu Dizgin",
  "item.minecraft.painting": "Tablo",
  "item.minecraft.pale_oak_boat": "Soluk Meşe Tekne",
  "item.minecraft.pale_oak_chest_boat": "Sandıklı Soluk Meşe Tekne",
  "item.minecraft.panda_spawn_egg": "Panda Çağırma Yumurtası",
  "item.minecraft.paper": "Kâğıt",
  "item.minecraft.parched_spawn_egg": "Kavruk Çağırma Yumurtası",
  "item.minecraft.parrot_spawn_egg": "Papağan Çağırma Yumurtası",
  "item.minecraft.phantom_membrane": "Kâbus Zarı",
  "item.minecraft.phantom_spawn_egg": "Kâbus Çağırma Yumurtası",
  "item.minecraft.pig_spawn_egg": "Domuz Çağırma Yumurtası",
  "item.minecraft.piglin_banner_pattern": "Sancak Deseni",
  "item.minecraft.piglin_banner_pattern.desc": "Domuz Burnu",
  "item.minecraft.piglin_banner_pattern.new": "Domuz Burnu Sancak Deseni",
  "item.minecraft.piglin_brute_spawn_egg": "Zalim Piglin Çağırma Yumurtası",
  "item.minecraft.piglin_spawn_egg": "Piglin Çağırma Yumurtası",
  "item.minecraft.pillager_spawn_egg": "Yağmacı Çağırma Yumurtası",
  "item.minecraft.pink_bundle": "Pembe Kese",
  "item.minecraft.pink_dye": "Pembe Boya",
  "item.minecraft.pink_harness": "Pembe Dizgin",
  "item.minecraft.pitcher_plant": "Sürahi Bitkisi",
  "item.minecraft.pitcher_pod": "Sürahi Bitkisi Tohum Zarfı",
  "item.minecraft.plenty_pottery_shard": "Bereket Çömlek Parçası",
  "item.minecraft.plenty_pottery_sherd": "Güzel Çömlek Parçası",
  "item.minecraft.poisonous_potato": "Zehirli Patates",
  "item.minecraft.polar_bear_spawn_egg": "Kutup Ayısı Çağırma Yumurtası",
  "item.minecraft.popped_chorus_fruit": "Patlamış Nakarat Meyvesi",
  "item.minecraft.porkchop": "Çiğ Domuz Pirzolası",
  "item.minecraft.potato": "Patates",
  "item.minecraft.potion": "İksir",
  "item.minecraft.potion.effect.awkward": "Garip İksir",
  "item.minecraft.potion.effect.empty": "Üretilemeyen İksir",
  "item.minecraft.potion.effect.fire_resistance": "Ateş Direnci İksiri",
  "item.minecraft.potion.effect.harming": "Hasar İksiri",
  "item.minecraft.potion.effect.healing": "İyileştirme İksiri",
  "item.minecraft.potion.effect.infested": "Enfeksiyon İksiri",
  "item.minecraft.potion.effect.invisibility": "Görünmezik İksiri",
  "item.minecraft.potion.effect.leaping": "Sıçrama İksiri",
  "item.minecraft.potion.effect.levitation": "Yükselme İksiri",
  "item.minecraft.potion.effect.luck": "Şans İksiri",
  "item.minecraft.potion.effect.mundane": "Sıradan İksir",
  "item.minecraft.potion.effect.night_vision": "Gece Görüş İksiri",
  "item.minecraft.potion.effect.oozing": "Sızma İksiri",
  "item.minecraft.potion.effect.poison": "Zehir İksiri",
  "item.minecraft.potion.effect.regeneration": "Yenilenme İksiri",
  "item.minecraft.potion.effect.slow_falling": "Yavaş Düşüş İksiri",
  "item.minecraft.potion.effect.slowness": "Yavaşlık İksiri",
  "item.minecraft.potion.effect.strength": "Kuvvet İksiri",
  "item.minecraft.potion.effect.swiftness": "Çeviklik İksiri",
  "item.minecraft.potion.effect.thick": "Yoğun İksir",
  "item.minecraft.potion.effect.turtle_master": "Kaplumbağa Ustası İksiri",
  "item.minecraft.potion.effect.water": "Su Şişesi",
  "item.minecraft.potion.effect.water_breathing": "Su Altında Nefes Alma İksiri",
  "item.minecraft.potion.effect.weakness": "Zayıflık İksiri",
  "item.minecraft.potion.effect.weaving": "Örme İksiri",
  "item.minecraft.potion.effect.wind_charged": "Rüzgâr Dolu İksir",
  "item.minecraft.pottery_shard_archer": "Okçu Çömlek Parçası",
  "item.minecraft.pottery_shard_arms_up": "Eller Yukarı Çömlek Parçası",
  "item.minecraft.pottery_shard_prize": "Ödül Çömlek Parçası",
  "item.minecraft.pottery_shard_skull": "Kafatası Çömlek Parçası",
  "item.minecraft.powder_snow_bucket": "Tozlaşmış Kar Kovası",
  "item.minecraft.prismarine_crystals": "Prizmarin Kristali",
  "item.minecraft.prismarine_shard": "Prizmarin Parçacığı",
  "item.minecraft.prize_pottery_shard": "Ödül Çömlek Parçası",
  "item.minecraft.prize_pottery_sherd": "Ödül Çömlek Parçası",
  "item.minecraft.pufferfish": "Kirpi Balığı",
  "item.minecraft.pufferfish_bucket": "Kirpi Balığı Kovası",
  "item.minecraft.pufferfish_spawn_egg": "Kirpi Balığı Çağırma Yumurtası",
  "item.minecraft.pumpkin_pie": "Bal Kabağı Turtası",
  "item.minecraft.pumpkin_seeds": "Bal Kabağı Tohumu",
  "item.minecraft.purple_bundle": "Mor Kese",
  "item.minecraft.purple_dye": "Mor Boya",
  "item.minecraft.purple_harness": "Mor Dizgin",
  "item.minecraft.quartz": "Nether Kuvarsı",
  "item.minecraft.rabbit": "Çiğ Tavşan Eti",
  "item.minecraft.rabbit_foot": "Tavşan Ayağı",
  "item.minecraft.rabbit_hide": "Tavşan Postu",
  "item.minecraft.rabbit_spawn_egg": "Tavşan Çağırma Yumurtası",
  "item.minecraft.rabbit_stew": "Tavşan Güveci",
  "item.minecraft.raiser_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Yükseltici Zırh Süslemesi",
  "item.minecraft.ravager_spawn_egg": "Yıkıcı Çağırma Yumurtası",
  "item.minecraft.raw_copper": "Ham Bakır",
  "item.minecraft.raw_gold": "Ham Altın",
  "item.minecraft.raw_iron": "Ham Demir",
  "item.minecraft.recovery_compass": "Kurtarma Pusulası",
  "item.minecraft.red_bundle": "Kırmızı Kese",
  "item.minecraft.red_dye": "Kırmızı Boya",
  "item.minecraft.red_harness": "Kırmızı Dizgin",
  "item.minecraft.redstone": "Redstone Tozu",
  "item.minecraft.resin_brick": "Reçine Tuğla",
  "item.minecraft.resin_clump": "Reçine Yığını",
  "item.minecraft.rib_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Kaburga Zırh Süslemesi",
  "item.minecraft.rotten_flesh": "Çürük Et",
  "item.minecraft.saddle": "Eyer",
  "item.minecraft.salmon": "Çiğ Somon",
  "item.minecraft.salmon_bucket": "Somon Kovası",
  "item.minecraft.salmon_spawn_egg": "Somon Çağırma Yumurtası",
  "item.minecraft.scrape_pottery_sherd": "Kazıma Çömlek Parçası",
  "item.minecraft.scute": "Pul",
  "item.minecraft.sentry_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Nöbetçi Zırh Süslemesi",
  "item.minecraft.shaper_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Şekillendirici Zırh Süslemesi",
  "item.minecraft.sheaf_pottery_shard": "Demet Çömlek Parçası",
  "item.minecraft.sheaf_pottery_sherd": "Demet Çömlek Parçası",
  "item.minecraft.shears": "Makas",
  "item.minecraft.sheep_spawn_egg": "Koyun Çağırma Yumurtası",
  "item.minecraft.shelter_pottery_shard": "Barınak Çömlek Parçası",
  "item.minecraft.shelter_pottery_sherd": "Barınak Çömlek Parçası",
  "item.minecraft.shield": "Kalkan",
  "item.minecraft.shield.black": "Siyah Kalkan",
  "item.minecraft.shield.blue": "Mavi Kalkan",
  "item.minecraft.shield.brown": "Kahverengi Kalkan",
  "item.minecraft.shield.cyan": "Camgöbeği Kalkan",
  "item.minecraft.shield.gray": "Gri Kalkan",
  "item.minecraft.shield.green": "Yeşil Kalkan",
  "item.minecraft.shield.light_blue": "Açık Mavi Kalkan",
  "item.minecraft.shield.light_gray": "Açık Gri Kalkan",
  "item.minecraft.shield.lime": "Açık Yeşil Kalkan",
  "item.minecraft.shield.magenta": "Eflatun Kalkan",
  "item.minecraft.shield.orange": "Turuncu Kalkan",
  "item.minecraft.shield.pink": "Pembe Kalkan",
  "item.minecraft.shield.purple": "Mor Kalkan",
  "item.minecraft.shield.red": "Kırmızı Kalkan",
  "item.minecraft.shield.white": "Beyaz Kalkan",
  "item.minecraft.shield.yellow": "Sarı Kalkan",
  "item.minecraft.shulker_shell": "Shulker Kabuğu",
  "item.minecraft.shulker_spawn_egg": "Shulker Çağırma Yumurtası",
  "item.minecraft.sign": "Tabela",
  "item.minecraft.silence_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Sessizlik Zırh Süslemesi",
  "item.minecraft.silverfish_spawn_egg": "Gümüşçün Çağırma Yumurtası",
  "item.minecraft.skeleton_horse_spawn_egg": "İskelet At Çağırma Yumurtası",
  "item.minecraft.skeleton_spawn_egg": "İskelet Çağırma Yumurtası",
  "item.minecraft.skull_banner_pattern": "Sancak Deseni",
  "item.minecraft.skull_banner_pattern.desc": "Kafatası Şekli",
  "item.minecraft.skull_banner_pattern.new": "Kuru Kafa Şekli Sancak Deseni",
  "item.minecraft.skull_pottery_shard": "Kafatası Çömlek Parçası",
  "item.minecraft.skull_pottery_sherd": "Kafatası Çömlek Parçası",
  "item.minecraft.slime_ball": "Balçık Topu",
  "item.minecraft.slime_spawn_egg": "Balçık Çağırma Yumurtası",
  "item.minecraft.smithing_template": "Demirci Şablonu",
  "item.minecraft.smithing_template.applies_to": "Şunlar için:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Külçe veya kristal ekleyin",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Zırh",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Bir zırh parçası ekleyin",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Külçeler ve Kristaller",
  "item.minecraft.smithing_template.ingredients": "Malzemeler:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netherit Külçesi ekleyin",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Elmas Ekipman",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Elmas zırh, silah veya alet ekleyin",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherit Külçesi",
  "item.minecraft.smithing_template.upgrade": "Yükseltme: ",
  "item.minecraft.sniffer_spawn_egg": "Koklarca Çağırma Yumurtası",
  "item.minecraft.snort_pottery_shard": "Koklama Çömlek Parçası",
  "item.minecraft.snort_pottery_sherd": "Horlayan Çömlek Parçası",
  "item.minecraft.snout_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Domuz Burnu Zırh Süslemesi",
  "item.minecraft.snow_golem_spawn_egg": "Kar Golemi Çağırma Yumurtası",
  "item.minecraft.snowball": "Kar Topu",
  "item.minecraft.spectral_arrow": "Spektral Ok",
  "item.minecraft.spider_eye": "Örümcek Gözü",
  "item.minecraft.spider_spawn_egg": "Örümcek Çağırma Yumurtası",
  "item.minecraft.spire_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Sarmal Zırh Süslemesi",
  "item.minecraft.splash_potion": "Patlayıcı İksir",
  "item.minecraft.splash_potion.effect.awkward": "Patlayıcı Garip İksir",
  "item.minecraft.splash_potion.effect.empty": "Patlayıcı Üretilemeyen İksir",
  "item.minecraft.splash_potion.effect.fire_resistance": "Patlayıcı Ateş Direnci İksiri",
  "item.minecraft.splash_potion.effect.harming": "Patlayıcı Hasar İksiri",
  "item.minecraft.splash_potion.effect.healing": "Patlayıcı İyileştirme İksiri",
  "item.minecraft.splash_potion.effect.infested": "Patlayıcı Enfeksiyon İksiri",
  "item.minecraft.splash_potion.effect.invisibility": "Patlayıcı Görünmezik İksiri",
  "item.minecraft.splash_potion.effect.leaping": "Patlayıcı Sıçrama İksiri",
  "item.minecraft.splash_potion.effect.levitation": "Patlayıcı Yükselme İksiri",
  "item.minecraft.splash_potion.effect.luck": "Patlayıcı Şans İksiri",
  "item.minecraft.splash_potion.effect.mundane": "Patlayıcı Sıradan İksir",
  "item.minecraft.splash_potion.effect.night_vision": "Patlayıcı Gece Görüş İksiri",
  "item.minecraft.splash_potion.effect.oozing": "Patlayıcı Sızma İksiri",
  "item.minecraft.splash_potion.effect.poison": "Patlayıcı Zehir İksiri",
  "item.minecraft.splash_potion.effect.regeneration": "Patlayıcı Yenilenme İksiri",
  "item.minecraft.splash_potion.effect.slow_falling": "Patlayıcı Yavaş Düşüş İksiri",
  "item.minecraft.splash_potion.effect.slowness": "Patlayıcı Yavaşlık İksiri",
  "item.minecraft.splash_potion.effect.strength": "Patlayıcı Kuvvet İksiri",
  "item.minecraft.splash_potion.effect.swiftness": "Patlayıcı Çeviklik İksiri",
  "item.minecraft.splash_potion.effect.thick": "Patlayıcı Yoğun İksir",
  "item.minecraft.splash_potion.effect.turtle_master": "Patlayıcı Kaplumbağa Ustası İksiri",
  "item.minecraft.splash_potion.effect.water": "Patlayıcı Su Şişesi",
  "item.minecraft.splash_potion.effect.water_breathing": "Patlayıcı Su Altında Nefes Alma İksiri",
  "item.minecraft.splash_potion.effect.weakness": "Patlayıcı Zayıflık İksiri",
  "item.minecraft.splash_potion.effect.weaving": "Patlayıcı Örme İksiri",
  "item.minecraft.splash_potion.effect.wind_charged": "Rüzgâr Dolu Patlayıcı İksir",
  "item.minecraft.spruce_boat": "Ladin Tekne",
  "item.minecraft.spruce_chest_boat": "Sandıklı Ladin Tekne",
  "item.minecraft.spyglass": "Dürbün",
  "item.minecraft.squid_spawn_egg": "Mürekkep Balığı Çağırma Yumurtası",
  "item.minecraft.stick": "Çubuk",
  "item.minecraft.stone_axe": "Taş Balta",
  "item.minecraft.stone_hoe": "Taş Çapa",
  "item.minecraft.stone_pickaxe": "Taş Kazma",
  "item.minecraft.stone_shovel": "Taş Kürek",
  "item.minecraft.stone_spear": "Taş Mızrak",
  "item.minecraft.stone_sword": "Taş Kılıç",
  "item.minecraft.stray_spawn_egg": "Serseri Çağırma Yumurtası",
  "item.minecraft.strider_spawn_egg": "Lavgezer Çağırma Yumurtası",
  "item.minecraft.string": "İp",
  "item.minecraft.sugar": "Şeker",
  "item.minecraft.suspicious_stew": "Şüpheli Güveç",
  "item.minecraft.sweet_berries": "Tatlı Orman Meyveleri",
  "item.minecraft.tadpole_bucket": "İribaş Kovası",
  "item.minecraft.tadpole_spawn_egg": "İribaş Çağırma Yumurtası",
  "item.minecraft.tide_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gelgit Zırh Süslemesi",
  "item.minecraft.tipped_arrow": "İksirli Ok",
  "item.minecraft.tipped_arrow.effect.awkward": "İksirli Ok",
  "item.minecraft.tipped_arrow.effect.empty": "Üretilemeyen İksirli Ok",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Ateş Direnci Oku",
  "item.minecraft.tipped_arrow.effect.harming": "Hasar Oku",
  "item.minecraft.tipped_arrow.effect.healing": "İyileştirme Oku",
  "item.minecraft.tipped_arrow.effect.infested": "Enfeksiyon Oku",
  "item.minecraft.tipped_arrow.effect.invisibility": "Görünmezlik Oku",
  "item.minecraft.tipped_arrow.effect.leaping": "Sıçrama Oku",
  "item.minecraft.tipped_arrow.effect.levitation": "Yükselme Oku",
  "item.minecraft.tipped_arrow.effect.luck": "Şans Oku",
  "item.minecraft.tipped_arrow.effect.mundane": "İksirli Ok",
  "item.minecraft.tipped_arrow.effect.night_vision": "Gece Görüşü Oku",
  "item.minecraft.tipped_arrow.effect.oozing": "Sızma Oku",
  "item.minecraft.tipped_arrow.effect.poison": "Zehir Oku",
  "item.minecraft.tipped_arrow.effect.regeneration": "Yenilenme Oku",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Yavaş Düşüş Oku",
  "item.minecraft.tipped_arrow.effect.slowness": "Yavaşlık Oku",
  "item.minecraft.tipped_arrow.effect.strength": "Kuvvet Oku",
  "item.minecraft.tipped_arrow.effect.swiftness": "Çeviklik Oku",
  "item.minecraft.tipped_arrow.effect.thick": "İksirli Ok",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Kaplumbağa Ustası Oku",
  "item.minecraft.tipped_arrow.effect.water": "Su Oku",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Su Altında Nefes Alma Oku",
  "item.minecraft.tipped_arrow.effect.weakness": "Zayıflık Oku",
  "item.minecraft.tipped_arrow.effect.weaving": "Örme Oku",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Rüzgârla Doldurma Oku",
  "item.minecraft.tnt_minecart": "TNT’li Vagon",
  "item.minecraft.torchflower_seeds": "Meşale Çiçeği Tohumu",
  "item.minecraft.totem_of_undying": "Ölümsüzlük Totemi",
  "item.minecraft.trader_llama_spawn_egg": "Tüccar Lama Çağırma Yumurtası",
  "item.minecraft.trial_key": "Sınama Anahtarı",
  "item.minecraft.trident": "Üçlü Mızrak",
  "item.minecraft.tropical_fish": "Tropikal Balık",
  "item.minecraft.tropical_fish_bucket": "Tropikal Balık Kovası",
  "item.minecraft.tropical_fish_spawn_egg": "Tropikal Balık Çağırma Yumurtası",
  "item.minecraft.turtle_helmet": "Kaplumbağa Kabuğu",
  "item.minecraft.turtle_scute": "Kaplumbağa Pulu",
  "item.minecraft.turtle_spawn_egg": "Kaplumbağa Çağırma Yumurtası",
  "item.minecraft.vex_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Sinirbozan Zırh Süslemesi",
  "item.minecraft.vex_spawn_egg": "Sinirbozan Çağırma Yumurtası",
  "item.minecraft.villager_spawn_egg": "Köylü Çağırma Yumurtası",
  "item.minecraft.vindicator_spawn_egg": "İntikamcı Çağırma Yumurtası",
  "item.minecraft.wandering_trader_spawn_egg": "Seyyar Tüccar Çağırma Yumurtası",
  "item.minecraft.ward_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Koğuş Zırh Süslemesi",
  "item.minecraft.warden_spawn_egg": "Muhafız Çağırma Yumurtası",
  "item.minecraft.warped_fungus_on_a_stick": "Çarpık Mantarlı Olta",
  "item.minecraft.water_bucket": "Su Kovası",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Yol Bulucu Zırh Süslemesi",
  "item.minecraft.wheat": "Buğday",
  "item.minecraft.wheat_seeds": "Buğday Tohumu",
  "item.minecraft.white_bundle": "Beyaz Kese",
  "item.minecraft.white_dye": "Beyaz Boya",
  "item.minecraft.white_harness": "Beyaz Dizgin",
  "item.minecraft.wild_armor_trim_smithing_template": "Demirci Şablonu",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Yabani Zırh Süslemesi",
  "item.minecraft.wind_charge": "Rüzgâr Topu",
  "item.minecraft.witch_spawn_egg": "Cadı Çağırma Yumurtası",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither İskeleti Çağırma Yumurtası",
  "item.minecraft.wither_spawn_egg": "Wither Çağırma Yumurtası",
  "item.minecraft.wolf_armor": "Kurt Zırhı",
  "item.minecraft.wolf_spawn_egg": "Kurt Çağırma Yumurtası",
  "item.minecraft.wooden_axe": "Tahta Balta",
  "item.minecraft.wooden_hoe": "Tahta Çapa",
  "item.minecraft.wooden_pickaxe": "Tahta Kazma",
  "item.minecraft.wooden_shovel": "Tahta Kürek",
  "item.minecraft.wooden_spear": "Tahta Mızrak",
  "item.minecraft.wooden_sword": "Tahta Kılıç",
  "item.minecraft.writable_book": "Kitap ve Kalem",
  "item.minecraft.written_book": "Yazılı Kitap",
  "item.minecraft.yellow_bundle": "Sarı Kese",
  "item.minecraft.yellow_dye": "Sarı Boya",
  "item.minecraft.yellow_harness": "Sarı Dizgin",
  "item.minecraft.zoglin_spawn_egg": "Zoglin Çağırma Yumurtası",
  "item.minecraft.zombie_horse_spawn_egg": "Zombi At Çağırma Yumurtası",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombi Notilus Çağırma Yumurtası",
  "item.minecraft.zombie_spawn_egg": "Zombi Çağırma Yumurtası",
  "item.minecraft.zombie_villager_spawn_egg": "Zombi Köylü Çağırma Yumurtası",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombileşmiş Piglin Çağırma Yumurtası"
}
export const tr_tr = items; 
